import { getPathLanguage } from "@/lib/i18n";

const TEXT_TRANSLATIONS = {
  fr: {
    Privacy: "Confidentialité",
    Public: "Public",
    Unlisted: "Non répertoriée",
    Private: "Privée",
    Scene: "Scène",
    "Scene {number}": "Scène {number}",
    Duration: "Durée",
    "Scene {number} media": "Média de la scène {number}",
    "Select to upload media": "Importer un média",
    "Media uploaded": "Média importé",
    "Add Text": "Ajouter Texte",
    "Add Shape": "Ajouter Forme",
    "Add scene": "Ajouter Scène",
    "Delete Scene {number}": "Supprimer la scène {number}",
    "Duration follows the uploaded video": "La durée suit celle de la vidéo importée",
    "Scene duration": "Durée de la scène",
    "Custom video scenes": "Scènes vidéo personnalisées",
    "Video clips set each scene's duration automatically.":
      "Les clips vidéo définissent automatiquement la durée de chaque scène.",
    "Questions? Chat with us": "Des questions ? Discutez avec nous",
    Shape: "Forme",
    "Shape Settings": "Paramètres de la forme",
    "Square / Rectangle": "Carré / Rectangle",
    "Circle / Oval": "Cercle / Ovale",
    "Shape Styling": "Style de la forme",
    "Background Color": "Couleur d’arrière-plan",
    "Background Opacity": "Opacité de l’arrière-plan",
    "Border Color": "Couleur de la bordure",
    "Border Width (px)": "Largeur de la bordure (px)",
    "X Position (%)": "Position X (%)",
    "Y Position (%)": "Position Y (%)",
    "Width (%)": "Largeur (%)",
    "Height (%)": "Hauteur (%)",
    Scale: "Échelle",
    "Rotation (°)": "Rotation (°)",
    "Layer Opacity": "Opacité du calque",
    "Corner Position Offsets (%)": "Décalages de position des coins (%)",
    "Offsets are relative to the shape's width and height. Positive Y moves a corner down.":
      "Les décalages sont relatifs à la largeur et à la hauteur de la forme. Une valeur Y positive déplace un coin vers le bas.",
    "Shape Corner Radius (px)": "Rayon des coins de la forme (px)",
    "All corners": "Tous les coins",
    "Top left": "En haut à gauche",
    "Top right": "En haut à droite",
    "Bottom right": "En bas à droite",
    "Bottom left": "En bas à gauche",
    Position: "Position",
    "Adjust position": "Ajuster la position",
    "Width %": "Largeur %",
    "Height %": "Hauteur %",
    Top: "Haut",
    Middle: "Milieu",
    Bottom: "Bas",
    "Client review recording page settings":
      "Paramètres de la page d’enregistrement des avis clients",
    "Customize the public page your clients use to record video reviews, then share the link or download the printable QR page.":
      "Personnalisez la page publique que vos clients utilisent pour enregistrer des avis vidéo, puis partagez le lien ou téléchargez la page QR imprimable.",
    "Upload your logo (optional)": "Importez votre logo (facultatif)",
    "Name of the establishment/company/place":
      "Nom de l’établissement/de l’entreprise/du lieu",
    "Text for the review recording page":
      "Texte de la page d’enregistrement des avis",
    "Text above the QR code": "Texte au-dessus du QR code",
    "Save client review settings":
      "Enregistrer les paramètres des avis clients",
    "Open recording page": "Ouvrir la page d’enregistrement",
    Record: "Enregistrer",
    "Max duration: 30s": "Durée maximale : 30 s",
    "Client Review Draft": "Brouillon d’avis client",
    "Client review tools": "Outils d’avis client",
    "Client review video": "Vidéo d’avis client",
    "Trim recorded video": "Rogner la vidéo enregistrée",
    "Remove from beginning (seconds)": "Supprimer au début (secondes)",
    "Remove from end (seconds)": "Supprimer à la fin (secondes)",
    "Example: use 1.0 to remove the first second while the client adjusts their phone.":
      "Exemple : utilisez 1,0 pour supprimer la première seconde pendant que le client ajuste son téléphone.",
    "Optional logo": "Logo facultatif",
    "Upload optional logo": "Importer un logo facultatif",
    "Optional. If no logo is uploaded, nothing will appear in the final video. Uploaded logos are limited to the top-right 150px area.":
      "Facultatif. Si aucun logo n’est importé, rien n’apparaîtra dans la vidéo finale. Les logos importés sont limités à la zone de 150 px en haut à droite.",
    "Optional caption": "Légende facultative",
    "Optional. Maximum 2 lines; leave empty to hide this text.":
      "Facultatif. 2 lignes maximum ; laissez vide pour masquer ce texte.",
    "Share to social media": "Partager sur les réseaux sociaux",
    "Create your first video": "Créez votre première vidéo",
    "View pricing": "Voir les tarifs",
    Templates: "Modèles",
    Pricing: "Tarifs",
    "Please fill all required fields. VAT is optional.":
      "Veuillez remplir tous les champs obligatoires. La TVA est facultative.",
    "Payment failed. Please try again.":
      "Le paiement a échoué. Veuillez réessayer.",
    "VAT check service is temporarily unavailable. VAT was applied by default.":
      "Le service de vérification de TVA est temporairement indisponible. La TVA a été appliquée par défaut.",
    "Valid VAT number detected. VAT not applied.":
      "Numéro de TVA valide détecté. TVA non appliquée.",
    "VAT number not valid.": "Numéro de TVA invalide.",
    "Spanish VAT numbers (ES) still include 21% VAT.":
      "Les numéros de TVA espagnols (ES) incluent toujours 21 % de TVA.",
    "21% VAT applied.": "TVA de 21 % appliquée.",
    "21% VAT is added when applicable.":
      "La TVA de 21 % est ajoutée lorsque c'est applicable.",
    "Export started!": "L'export a démarré !",
    "Failed to start export": "Impossible de démarrer l'export",
    "You reached your monthly export limit. Upgrade your plan or buy extra video exports.":
      "Vous avez atteint votre limite mensuelle d'exports. Passez à une offre supérieure ou achetez des exports supplémentaires.",
    Category: "Catégorie",
    Language: "Langue",
    English: "Anglais",
    French: "Français",
    Spanish: "Espagnol",
    "Simple & Visual video templates": "Modèles vidéo simples et visuels",
    "Fun & Creative video templates": "Modèles vidéo fun et créatifs",
    "Transform Image to video with AI":
      "Transformer une image en vidéo avec l'IA",
    "Turn any static image into a ready-to-post video. These templates already include optimized AI prompts, so you just upload your image, click “Generate Video,” then edit or remove the text before exporting and sharing.":
      "Transformez n’importe quelle image statique en vidéo prête à publier. Ces modèles incluent déjà des prompts IA optimisés : il vous suffit d’importer votre image, de cliquer sur « Générer la vidéo », puis de modifier ou supprimer le texte avant d’exporter et de partager.",
    "Instead of posting an image, turn it into an engaging video post. Whether it’s a single photo or a 4-image slideshow, these templates add smooth animations and text to help your posts reach more people.":
      "Au lieu de publier une image, transformez-la en publication vidéo engageante. Qu’il s’agisse d’une seule photo ou d’un diaporama de 4 images, ces modèles ajoutent des animations fluides et du texte pour aider vos publications à toucher plus de personnes.",
    "Grab attention with short, humorous videos featuring an actor in everyday situations. Perfect for ads or posts that feel like mini-stories and make your audience smile.":
      "Attirez l’attention avec de courtes vidéos humoristiques mettant en scène un acteur dans des situations du quotidien. Idéal pour des publicités ou publications qui ressemblent à des mini-histoires et font sourire votre audience.",
    "Subscription activated successfully!": "Abonnement activé avec succès !",
    "Unable to save your information.":
      "Impossible d'enregistrer vos informations.",
    "Unable to create account.": "Impossible de créer le compte.",
    "PayPal is not configured yet. Please try again in a few minutes.":
      "PayPal n'est pas encore configuré. Veuillez réessayer dans quelques minutes.",
    "Media uploaded successfully": "Média téléchargé avec succès",
    "Failed to upload media": "Échec du téléchargement du média",
    "Media removed": "Média supprimé",
    "Begin uploaded video at (seconds)":
      "Commencer la vidéo importée à (secondes)",
    "Your uploaded video is": "Votre vidéo importée dure",
    "and the layer is": "et la couche dure",
    "Move forward to show a specific portion inside this layer.":
      "Avancez dans la vidéo pour afficher une partie précise dans cette couche.",
    "Move the uploaded video forward to choose which part appears inside this layer.":
      "Avancez dans la vidéo importée pour choisir la partie qui apparaît dans cette couche.",
    "No AI prompt configured for this layer":
      "Aucun prompt IA configuré pour cette couche",
    "Please upload an image first": "Veuillez d'abord télécharger une image",
    "Generating AI video...": "Génération de la vidéo IA...",
    "AI video ready, replaced the image in this layer":
      "Vidéo IA prête, l'image a été remplacée dans cette couche",
    "Timed out waiting for PixVerse video":
      "Délai dépassé en attendant la vidéo PixVerse",
    "AI generation failed": "La génération IA a échoué",
    "Videos get more reach than images on social media":
      "Les vidéos ont une portée nettement supérieure aux photos sur les réseaux sociaux",
    "Your posts aren’t reaching new clients. Here’s why.":
      "Vos publications n’atteignent pas de nouveaux clients. Voici pourquoi.",
    "Image posts are shown mostly to your followers. Videos get pushed to people who don’t follow you.":
      "Les publications image sont surtout montrées à vos abonnés. Les vidéos sont diffusées à des personnes qui ne vous suivent pas.",
    "Turn your images into videos in 2 minutes with our templates, and publish to all your social platforms in just one click.":
      "Transformez vos images en vidéos en 2 minutes avec nos modèles, et publiez sur toutes vos plateformes sociales en un seul clic.",
    "Reach new clients by posting videos instead of images":
      "Touchez de nouveaux clients en publiant des vidéos à la place de photos",
    "From just 1€ per video • 50% OFF first month":
      "À partir de 1 € par vidéo • -50 % le premier mois",
    "Tap video to play": "Touchez la vidéo pour lire",
    "Creating videos takes time and money":
      "Créer des vidéos demande du temps et de l’argent",
    "If you have the budget to create professional videos, or the time to film and edit videos yourself, quality content is one of the best ways to attract new followers and reach new clients.":
      "Si vous avez le budget pour créer des vidéos professionnelles, ou le temps de filmer et monter vous-même, un contenu de qualité est l’un des meilleurs moyens d’attirer de nouveaux abonnés et de nouveaux clients.",
    "The problem is consistency.": "Le problème, c’est la régularité.",
    "Most small businesses cannot afford to create professional videos every day, or even several times per week. And business owners who create content themselves usually do not have hours to spend filming, editing and exporting videos.":
      "La plupart des petites entreprises ne peuvent pas se permettre de créer des vidéos professionnelles chaque jour, ni même plusieurs fois par semaine. Et les dirigeants qui créent eux-mêmes leur contenu n’ont généralement pas des heures à consacrer au tournage, au montage et à l’export.",
    "That is why we built CreaVideos.":
      "C’est pour cela que nous avons créé CreaVideos.",
    "The idea was simple: make it possible to create videos in minutes, without editing skills, without expensive production costs, and without spending hours in front of editing software.":
      "L’idée était simple : permettre de créer des vidéos en quelques minutes, sans compétences de montage, sans coûts de production élevés et sans passer des heures devant un logiciel de montage.",
    "Even if you already create professional videos for your business, CreaVideos can help you keep posting video content on the days where you would normally post images.":
      "Même si vous créez déjà des vidéos professionnelles pour votre entreprise, CreaVideos peut vous aider à continuer à publier du contenu vidéo les jours où vous publieriez normalement des images.",
    "Instead of publishing fewer videos because of time or budget, you can keep showing your business regularly with videos that take only minutes to create.":
      "Au lieu de publier moins de vidéos par manque de temps ou de budget, vous pouvez continuer à montrer votre activité régulièrement avec des vidéos créées en quelques minutes.",
    "Perfect for small businesses": "Parfait pour les petites entreprises",
    "If you post on social media and need a tool to help you create short videos faster, this is for you:":
      "Si vous publiez sur les réseaux sociaux et avez besoin d’un outil pour vous aider à créer des vidéos courtes plus rapidement, c’est pour vous :",
    "Reach new clients for less than 1€ per post":
      "Touchez de nouveaux clients pour moins de 1 € par publication",
    "No agency. No editing. No expensive tools.":
      "Pas d’agence. Pas de montage. Pas d’outils coûteux.",
    "Just simple videos that help you get more visibility.":
      "Juste des vidéos simples qui vous donnent plus de visibilité.",
    "See what you can create": "Découvrez ce que vous pouvez créer",
    "Professional-looking videos made from simple images":
      "Des vidéos professionnelles créées à partir d’images simples",
    "Start reaching new clients with your video posts":
      "Commencez à toucher de nouveaux clients avec vos publications vidéo",
    "Turn your images into videos and start reaching new clients today.":
      "Transformez vos images en vidéos et commencez à toucher de nouveaux clients dès aujourd’hui.",
    Terms: "Conditions",
    Privacy: "Confidentialité",
    "Data Deletion": "Suppression des données",
    Support: "Support",
    "© 2025 CreaVideos. All rights reserved.":
      "© 2025 CreaVideos. Tous droits réservés.",
    "Choose a template": "Choisissez un modèle",
    "Upload your images or clips": "Importez vos images ou clips",
    "And even if you already know how to edit videos, CreaVideos can save you time.":
      "Et même si vous savez déjà monter des vidéos, CreaVideos peut vous faire gagner du temps.",
    "You don't need to spend time editing on a timeline, export files and upload content to every platform one by one.":
      "Vous n’avez pas besoin de passer du temps sur une timeline, d’exporter des fichiers puis de téléverser le contenu plateforme par plateforme.",
    "With our templates, your video can be ready in about 2 minutes, and published to all your social platforms in just one click. (Facebook, Instagram, Youtube and TikTok).":
      "Avec nos modèles, votre vidéo peut être prête en environ 2 minutes, et publiée sur toutes vos plateformes sociales en un seul clic. (Facebook, Instagram, Youtube et TikTok).",
    "The goal is not to replace professional video production.":
      "L’objectif n’est pas de remplacer la production vidéo professionnelle.",
    "It is to make posting videos regularly simple enough that any business can do it.":
      "Il est de rendre la publication régulière de vidéos suffisamment simple pour que toute entreprise puisse le faire.",
    "Because the more regularly you post videos, the more chances you have to reach people who are not already following your page and keep attracting new potential clients.":
      "Car plus vous publiez des vidéos régulièrement, plus vous avez de chances de toucher des personnes qui ne suivent pas encore votre page et d’attirer de nouveaux clients potentiels.",
    "quality content is one of the best ways to attract new followers and reach new clients":
      "un contenu de qualité est l’un des meilleurs moyens d’attirer de nouveaux abonnés et de nouveaux clients",
    "That is why we built CreaVideos":
      "C’est pour cela que nous avons créé CreaVideos",
    "make it possible to create videos in minutes, without editing skills":
      "permettre de créer des vidéos en quelques minutes, sans compétences de montage",
    "CreaVideos can help you keep posting video content on the days where you would normally post images":
      "CreaVideos peut vous aider à continuer à publier du contenu vidéo les jours où vous publieriez normalement des images",
    "you can keep showing your business regularly with videos":
      "vous pouvez continuer à montrer votre activité régulièrement avec des vidéos",
    "CreaVideos can save you time":
      "CreaVideos peut vous faire gagner du temps",
    "ready in about 2 minutes, and published to all your social platforms in just one click":
      "prête en environ 2 minutes, et publiée sur toutes vos plateformes sociales en un seul clic",
    "to make posting videos regularly simple":
      "de rendre la publication régulière de vidéos simple",
    "reach people who are not already following your page and keep attracting new potential clients":
      "toucher des personnes qui ne suivent pas encore votre page et attirer de nouveaux clients potentiels",
    "Customize your text": "Personnalisez votre texte",
    "Download or share your video": "Téléchargez ou partagez votre vidéo",
    "Reach new clients": "Touchez de nouveaux clients",
    "Your videos are pushed beyond your followers":
      "Vos vidéos sont diffusées au-delà de vos abonnés",
    "Create in minutes": "Créez en quelques minutes",
    "No learning curve, no editing skills needed":
      "Aucune courbe d’apprentissage, pas besoin de compétences en montage",
    Affordable: "Abordable",
    "From less than 1€ per video": "À partir de moins de 1 € par vidéo",
    "Made for social media": "Conçu pour les réseaux sociaux",
    "Perfect format for Instagram & Facebook":
      "Format parfait pour Instagram et Facebook",
    "Reuse your content": "Réutilisez votre contenu",
    "Turn your existing images into videos":
      "Transformez vos images existantes en vidéos",
    "Restaurants promoting dishes or menus":
      "Restaurants qui mettent en avant leurs plats ou menus",
    "Real estate listings": "Annonces immobilières",
    "Local shops announcing products and offers":
      "Commerces locaux annonçant produits et offres",
    "Beauty & fitness services": "Services de beauté et fitness",
    "Any business posting on Instagram or Facebook":
      "Toute entreprise publiant sur Instagram ou Facebook",
    "Plans from 19€/month": "Forfaits à partir de 19 €/mois",
    "Up to 100 videos/month": "Jusqu’à 100 vidéos/mois",
    "Cancel anytime": "Annulez à tout moment",
    "AI image to video generation": "Génération vidéo IA à partir d’image",
    "image with movement/slideshows": "image avec mouvement/diaporama",
    "Fun & Creative videos": "Vidéos fun et créatives",
    "Simple, transparent pricing": "Tarifs simples et transparents",
    "Every plan starts with a 50% discounted first month, then renews monthly.":
      "Chaque offre commence par un premier mois à -50 %, puis se renouvelle mensuellement.",
    "Most Popular": "Le plus populaire",
    "Extra video packs": "Packs de vidéos supplémentaires",
    "Need more exports this month? Add extra videos instantly.":
      "Besoin de plus d’exports ce mois-ci ? Ajoutez des vidéos supplémentaires instantanément.",
    "Temporary test plans": "Offres de test temporaires",
    "For renewal verification only. This can be removed after testing.":
      "Uniquement pour vérification de renouvellement. Peut être supprimé après les tests.",
    "Frequently asked questions": "Questions fréquentes",
    "Can I change plans later?": "Puis-je changer d’offre plus tard ?",
    "What payment methods do you accept?":
      "Quels moyens de paiement acceptez-vous ?",
    "Do unused exports roll over?":
      "Les exports non utilisés sont-ils reportés ?",
    "Can I cancel anytime?": "Puis-je annuler à tout moment ?",
    "Welcome back,": "Bienvenue,",
    "Create and manage your video projects": "Créez et gérez vos projets vidéo",
    "Exports Used": "Exports utilisés",
    "Videos Rendered": "Vidéos exportées",
    "Current Plan": "Abonnement actuel",
    "Recent Renders": "Exports récents",
    "Create New Video": "Créer une nouvelle vidéo",
    "My Account": "Mon compte",
    "My Subscription": "Mon abonnement",
    "View all": "Voir tout",
    Completed: "Terminés",
    Download: "Télécharger",
    "No renders yet": "Aucun export pour le moment",
    "Start by selecting a template and creating your first video":
      "Commencez par sélectionner un modèle et créer votre première vidéo",
    "Popular Templates": "Modèles populaires",
    "Terms of Service": "Conditions d’utilisation",
    "License Agreement": "Contrat de licence",
    "Privacy Policy": "Politique de confidentialité",
    "Last updated:": "Dernière mise à jour :",
    "Start for €": "Commencez pour",
    "(50% OFF first month)": "(50 % OFF le premier mois)",
    "Current Plan": "Abonnement actuel",
    Login: "Se connecter",
    Subscribe: "S’abonner",
    "You must subscribe or login to edit this template.":
      "Vous devez vous abonner ou vous connecter pour modifier ce modèle.",
    Buy: "Acheter",
    "Subscribe to": "S’abonner à",
    "First month": "Premier mois",
    "PayPal is temporarily unavailable. Please try again in a few minutes.":
      "PayPal est temporairement indisponible. Veuillez réessayer dans quelques minutes.",
    "Buy +": "Acheter +",
    "Extra videos pack": "Pack de vidéos supplémentaires",
    "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.":
      "Oui, vous pouvez passer à une offre supérieure ou inférieure à tout moment. Les changements prennent effet immédiatement.",
    "Payments are made through PayPal for secure payments but you don't have to create an account and can just use your Debit/credit card (Visa, Mastecard...).":
      "Les paiements sont effectués via PayPal de façon sécurisée, sans obligation de créer un compte. Vous pouvez payer avec votre carte bancaire (Visa, Mastercard...).",
    "No, exports reset at the beginning of each billing cycle.":
      "Non, les exports sont réinitialisés au début de chaque cycle de facturation.",
    "Yes, you can cancel your subscription at any time with no cancellation fees. Cancellation will take effect at the end of your cycle and your subscription will not renew.":
      "Oui, vous pouvez annuler votre abonnement à tout moment sans frais. L’annulation prendra effet à la fin de votre cycle et l’abonnement ne sera pas renouvelé.",
    "16 videos/month": "16 vidéos/mois",
    "31 videos/month": "31 vidéos/mois",
    "100 videos/month": "100 vidéos/mois",
    "300 videos/month": "300 vidéos/mois",
    "1 export/day": "1 export/jour",
    "Perfect to get started and post 4 videos per week":
      "Parfait pour démarrer et publier 4 vidéos par semaine",
    "Post every day and grow your business":
      "Publiez chaque jour et développez votre activité",
    "For freelancers and social media managers":
      "Pour les freelances et les gestionnaires de réseaux sociaux",
    "Post videos for multiple clients easily":
      "Publiez facilement des vidéos pour plusieurs clients",
    "Temporary daily test plan for renewal checks":
      "Offre de test quotidienne temporaire pour vérifier les renouvellements",
    "Start for": "Commencez pour",
    "/month": "/mois",
    "/day": "/jour",
    "Then monthly": "Puis mensuel",
    "Then daily": "Puis quotidien",
    "Save and Subscribe": "Enregistrer et s’abonner",
    "Saving...": "Enregistrement...",
    "First name": "Prénom",
    "Last name": "Nom",
    Email: "E-mail",
    Password: "Mot de passe",
    Country: "Pays",
    "Company name": "Nom de l’entreprise",
    Address: "Adresse",
    "Zip code": "Code postal",
    City: "Ville",
    Phone: "Téléphone",
    "Limited exports": "Exports limités",
    "Welcome back": "Bon retour",
    "Account Settings": "Paramètres du compte",
    "Profile Information": "Informations du profil",
    Security: "Sécurité",
    "Usage Statistics": "Statistiques d’utilisation",
    "Export Limit": "Limite d’exports",
    "Account Type": "Type de compte",
    "Save Changes": "Enregistrer les modifications",
    "Danger Zone": "Zone de danger",
    "Delete Account": "Supprimer le compte",
    "Once you delete your account, there is no going back. Please be certain and don't forget to cancel your subscription before deleting your account, clicking on the Manage Subscription button.":
      "Une fois votre compte supprimé, il n’y a pas de retour en arrière. Soyez certain(e) de votre décision et n’oubliez pas d’annuler votre abonnement avant de supprimer votre compte, en cliquant sur le bouton Gérer l’abonnement.",
    "Once you delete your account, there is no going back. Please be certain and don't forget to cancel your subscription before deleting your account, clicking on the Manage Abonnement button.":
      "Une fois votre compte supprimé, il n’y a pas de retour en arrière. Soyez certain(e) de votre décision et n’oubliez pas d’annuler votre abonnement avant de supprimer votre compte, en cliquant sur le bouton Gérer l’abonnement.",
    Subscription: "Abonnement",
    "No active": "Aucun actif",
    Cancelled: "Annulé",
    "Available Plans": "Offres disponibles",
    "Billing History": "Historique de facturation",
    "Your paid subscription ended.": "Votre abonnement payant a pris fin.",
    "Exports this month": "Exports ce mois-ci",
    "No billing history yet": "Aucun historique de facturation pour le moment",
    "Cancel Subscription": "Annuler l’abonnement",
    "Create and manage your video projects": "Créez et gérez vos projets vidéo",
    "Renders are automatically deleted after 2 months":
      "Les exports sont automatiquement supprimés après 2 mois",
    "Your video is ready!": "Votre vidéo est prête !",

    Starter: "Démarrer",
    Growth: "Croissance",
    Pro: "Pro",
    Agency: "Agence",
    "Layer Info": "Infos du calque",
    "Image Layer": "Calque image",
    "Generate AI Video": "Générer une vidéo IA",
    "Media Position": "Position du média",
    "Reset to Center": "Réinitialiser au centre",
    Animations: "Animations",
    "Entrance Animation": "Animation d’entrée",
    "Exit Animation": "Animation de sortie",
    "Continuous Animation": "Animation continue",
    "Upload image or video": "Téléverser une image ou une vidéo",
    "Record video with your camera": "Enregistrer une vidéo avec votre caméra",
    "Choose camera": "Choisir la caméra",
    "Which camera would you like to use for this recording?":
      "Quelle caméra souhaitez-vous utiliser pour cet enregistrement ?",
    "Use rear camera": "Utiliser la caméra arrière",
    "Use front camera": "Utiliser la caméra avant",
    "Thank you! Your review has been submitted.":
      "Merci ! Votre avis a été envoyé.",
    "Rear camera is recommended when filming something in front of you.":
      "La caméra arrière est recommandée pour filmer quelque chose devant vous.",
    "Start recording with your camera and it will stop automatically at the end of the clip":
      "Commencez à enregistrer avec votre caméra et l’enregistrement s’arrêtera automatiquement à la fin du clip",
    "Preparing camera...": "Préparation de la caméra...",
    "Recording...": "Enregistrement...",
    "Recording complete. Uploading video...":
      "Enregistrement terminé. Téléversement de la vidéo...",
    "Camera preview": "Aperçu de la caméra",
    "Recording will stop automatically":
      "L’enregistrement s’arrêtera automatiquement",
    "Camera recording is not supported by this browser":
      "L’enregistrement avec la caméra n’est pas pris en charge par ce navigateur",
    "Camera permission denied or unavailable":
      "Autorisation de la caméra refusée ou caméra indisponible",
    "Upload image": "Téléverser une image",
    "Remove image or video": "Supprimer l’image ou la vidéo",
    "text layer": "calque texte",
    "Text Content": "Contenu du texte",
    "Processing your video...": "Traitement de votre vidéo...",
    "Progress:": "Progression :",
    "This may take a few minutes depending on video length and complexity":
      "Cela peut prendre quelques minutes selon la durée et la complexité de la vidéo",
    "You reached your monthly exports limit. Upgrade your plan or buy extra video exports.":
      "Vous avez atteint votre limite mensuelle d’exports. Passez à une offre supérieure ou achetez des exports vidéo supplémentaires.",
    "Go to pricing": "Aller aux tarifs",
    "Upgrade for more exports":
      "Passez à une offre supérieure pour plus d’exports",
    "Cancel your subscription at period end?":
      "Annuler votre abonnement à la fin de la période ?",
    "Subscription cancellation scheduled. You keep access until the renewal date.":
      "Annulation de l’abonnement programmée. Vous conservez l’accès jusqu’à la date de renouvellement.",
    "Download Video": "Télécharger la vidéo",
    "Modify Video": "Modifier la vidéo",
    "This video revision is no longer available to modify":
      "Cette version de la vidéo n’est plus disponible pour modification",
    "Title (for Youtube only)": "Titre (pour YouTube uniquement)",
    "Caption/Description (for all the platforms)":
      "Légende/Description (pour toutes les plateformes)",
    "Share to all platforms": "Partager sur toutes les plateformes",
    "Please connect at least one platform before sharing.":
      "Veuillez connecter au moins une plateforme avant de partager.",
    "Shared successfully to": "Partagé avec succès sur",
    "Failed to share to": "Échec du partage sur",
    "Connect your social accounts first using the buttons below, then click Share to all platforms to publish automatically everywhere you're connected. You can connect one, two, or all platforms, and still use each platform's individual Share button after connecting. For TikTok, the video is sent to your account and you must finish posting inside the TikTok app or website.":
      "Connectez d’abord vos comptes sociaux avec les boutons ci-dessous, puis cliquez sur « Partager sur toutes les plateformes » pour publier automatiquement partout où vous êtes connecté. Vous pouvez connecter une, deux ou toutes les plateformes, et utiliser ensuite les boutons de partage individuels. Pour TikTok, la vidéo est envoyée sur votre compte et vous devez finaliser la publication dans l’application ou sur le site TikTok.",
    "Share on Instagram": "Partager sur Instagram",
    "Back to Dashboard": "Retour au tableau de bord",
    Delete: "Supprimer",
    Created: "Créé",
    Status: "Statut",
    completed: "terminé",
    Template: "Modèle",
    Progress: "Progression",
    Properties: "Propriétés",
    "Select an editable layer to view properties":
      "Sélectionnez un calque modifiable pour voir les propriétés",
    "Editable Layers": "Calques modifiables",
    "Export Video": "Exporter la vidéo",
    "No new visibility": "Pas de nouvelle visibilité",
    "No new clients": "Pas de nouveaux clients",
    "No growth": "Pas de croissance",
    Step: "Étape",
    "Step 1": "Étape 1",
    "Step 2": "Étape 2",
    "Step 3": "Étape 3",
    "Step 4": "Étape 4",
    "Video Templates": "Modèles vidéo",
    "Choose from professionally designed templates and make them your own":
      "Choisissez parmi des modèles conçus par des professionnels et personnalisez-les",
    "Search templates...": "Rechercher des modèles...",
    Format: "Format",
    "No templates found": "Aucun modèle trouvé",
    "Try adjusting your search or filters":
      "Essayez d’ajuster votre recherche ou vos filtres",
    "← Back to home": "← Retour à l’accueil",
    "1. Eligibility and Acceptance": "1. Éligibilité et acceptation",
    "2. Our Service": "2. Notre service",
    "3. Account Registration and Security": "3. Création de compte et sécurité",
    "4. Subscription Plans, Billing, and Renewal":
      "4. Abonnements, facturation et renouvellement",
    "5. Cancellation and Refunds": "5. Annulation et remboursements",
    "6. License Types and Usage Rights":
      "6. Types de licence et droits d’utilisation",
    "7. Template Access and Modification":
      "7. Accès et modification des modèles",
    "8. User Content and Responsibilities":
      "8. Contenu utilisateur et responsabilités",
    "9. Prohibited Uses": "9. Utilisations interdites",
    "10. Intellectual Property": "10. Propriété intellectuelle",
    "11. Feedback": "11. Retours",
    "12. Service Availability and Changes":
      "12. Disponibilité du service et modifications",
    "13. Third-Party Services": "13. Services tiers",
    "14. Privacy": "14. Confidentialité",
    "15. Termination and Suspension": "15. Résiliation et suspension",
    "16. Disclaimers": "16. Clauses de non-responsabilité",
    "17. Limitation of Liability": "17. Limitation de responsabilité",
    "18. Indemnification": "18. Indemnisation",
    "19. Governing Law": "19. Droit applicable",
    "20. Consumer Rights": "20. Droits des consommateurs",
    "21. Changes to Terms": "21. Modifications des conditions",
    "22. Entire Agreement": "22. Intégralité de l’accord",
    "23. Severability and Waiver": "23. Divisibilité et renonciation",
    "24. Facebook / Instagram Login and Integration":
      "24. Connexion et intégration Facebook / Instagram",
    "25. Contact": "25. Contact",
    "CreaVideos License Agreement": "Contrat de licence CreaVideos",
    "1. Grant of License": "1. Octroi de licence",
    "2. What You Can Do": "2. Ce que vous pouvez faire",
    "3. What You Cannot Do": "3. Ce que vous ne pouvez pas faire",
    "4. View Limit and Extended Use": "4. Limite de vues et usage étendu",
    "5. Ownership": "5. Propriété",
    "6. User Content": "6. Contenu utilisateur",
    "7. AI-Generated Content (PixVerse)": "7. Contenu généré par IA (PixVerse)",
    "8. Termination of License": "8. Résiliation de la licence",
    "9. No Warranty": "9. Absence de garantie",
    "10. Limitation of Liability": "10. Limitation de responsabilité",
    "11. Contact": "11. Contact",
    "1. Data Controller": "1. Responsable du traitement",
    "2. Personal Data We Collect":
      "2. Données personnelles que nous collectons",
    "3. How We Use Your Data": "3. Comment nous utilisons vos données",
    "4. Legal Basis (GDPR)": "4. Base légale (RGPD)",
    "5. Facebook / Instagram (Meta)": "5. Facebook / Instagram (Meta)",
    "6. Third-Party Services": "6. Services tiers",
    "7. Data Retention": "7. Conservation des données",
    "7.1 Data deletion instructions":
      "7.1 Instructions de suppression des données",
    "8. Your Rights (GDPR)": "8. Vos droits (RGPD)",
    "9. Data Security": "9. Sécurité des données",
    "10. International Transfers": "10. Transferts internationaux",
    "11. Cookies and Similar Technologies":
      "11. Cookies et technologies similaires",
    "What Are Cookies?": "Que sont les cookies ?",
    "How We Use Cookies": "Comment nous utilisons les cookies",
    "Authentication and session cookies":
      "Cookies d’authentification et de session",
    "Security cookies": "Cookies de sécurité",
    "Payment-related functionality": "Fonctionnalité liée aux paiements",
    "Social media integration": "Intégration des réseaux sociaux",
    "No Analytics or Marketing Cookies":
      "Pas de cookies d’analyse ou marketing",
    "Third-Party Services": "Services tiers",
    "Changes to This Section": "Modifications de cette section",
    "12. Changes to This Policy": "12. Modifications de cette politique",
    "13. Contact": "13. Contact",
    "These Terms + License + Privacy Policy = full agreement.":
      "Ces conditions + la licence + la politique de confidentialité = l’accord complet.",
    "If a part is invalid, the rest remains enforceable.":
      "Si une partie est invalide, le reste reste applicable.",
    "We do not sell this data.": "Nous ne vendons pas ces données.",
    "We never post without your explicit action.":
      "Nous ne publions jamais sans votre action explicite.",
    "Used only to:": "Utilisées uniquement pour :",
    "We may access:": "Nous pouvons accéder à :",
    "Welcome to CreaVideos.online (the “Website”), owned and operated by CreaVideos – Renaud Jean Noel Pomies (“CreaVideos”, “we”, “our”, or “us”).":
      "Bienvenue sur CreaVideos.online (« le Site »), détenu et exploité par CreaVideos – Renaud Jean Noel Pomies (« CreaVideos », « nous », « notre » ou « nos »).",
    "By accessing, browsing, creating an account, subscribing to, or using the Website and its services, you agree to be bound by these Terms of Service (“Terms”), as well as our":
      "En accédant au Site, en le parcourant, en créant un compte, en vous abonnant ou en utilisant le Site et ses services, vous acceptez d’être lié par ces Conditions d’utilisation (« Conditions »), ainsi que par notre",
    ", which are incorporated by reference. If you do not agree, you must not use the Website.":
      ", qui sont intégrés par référence. Si vous n’acceptez pas ces conditions, vous ne devez pas utiliser le Site.",
    "By using the Website, you represent and warrant that:":
      "En utilisant le Site, vous déclarez et garantissez que :",
    "you are at least 18 years old or have legal authorization,":
      "vous avez au moins 18 ans ou une autorisation légale,",
    "you have the legal capacity to enter into a binding agreement,":
      "vous avez la capacité juridique de conclure un accord contraignant,",
    "if acting on behalf of a company, you have authority to bind that entity.":
      "si vous agissez pour une entreprise, vous avez l’autorité pour engager cette entité.",
    "CreaVideos provides a subscription-based platform that allows users to:":
      "CreaVideos propose une plateforme par abonnement qui permet aux utilisateurs de :",
    "access video templates,": "accéder à des modèles vidéo,",
    "customize templates (text, images, videos),":
      "personnaliser les modèles (texte, images, vidéos),",
    "render and download finished videos,":
      "générer et télécharger des vidéos finalisées,",
    "use related tools and features.":
      "utiliser des outils et fonctionnalités associés.",
    "You must create an account to access certain features.":
      "Vous devez créer un compte pour accéder à certaines fonctionnalités.",
    "You agree to:": "Vous acceptez de :",
    "provide accurate and complete information,":
      "fournir des informations exactes et complètes,",
    "keep your login credentials secure,":
      "garder vos identifiants de connexion sécurisés,",
    "be responsible for all activity under your account.":
      "être responsable de toute activité effectuée sous votre compte.",
    "Account sharing is prohibited.": "Le partage de compte est interdit.",
    "Access is provided through subscription plans described on the Website.":
      "L’accès est fourni via les abonnements décrits sur le Site.",
    "You agree to pay all fees shown at purchase, including applicable taxes.":
      "Vous acceptez de payer tous les frais affichés lors de l’achat, y compris les taxes applicables.",
    "Subscriptions renew automatically unless cancelled before the renewal date.":
      "Les abonnements se renouvellent automatiquement sauf annulation avant la date de renouvellement.",
    "We may change pricing. Changes apply at your next renewal.":
      "Nous pouvons modifier les tarifs. Les changements s’appliquent à votre prochain renouvellement.",
    "Failed payments may result in suspension or termination of access.":
      "Les paiements échoués peuvent entraîner la suspension ou la résiliation de l’accès.",
    "You may cancel anytime via your account or by contacting us.":
      "Vous pouvez annuler à tout moment via votre compte ou en nous contactant.",
    "All purchases are non-refundable, except where required by law.":
      "Tous les achats sont non remboursables, sauf si la loi l’exige.",
    "Access continues until the end of your billing period.":
      "L’accès continue jusqu’à la fin de votre période de facturation.",
    "You are responsible for all content you upload.":
      "Vous êtes responsable de tout contenu que vous téléversez.",
    "You may not:": "Vous ne pouvez pas :",
    "All templates, software, and content belong to CreaVideos. You receive a license, not ownership.":
      "Tous les modèles, logiciels et contenus appartiennent à CreaVideos. Vous recevez une licence, pas la propriété.",
    "Any feedback you provide may be used freely without compensation.":
      "Tout commentaire que vous fournissez peut être utilisé librement sans compensation.",
    "We may modify or discontinue services at any time.":
      "Nous pouvons modifier ou interrompre les services à tout moment.",
    "No guarantee of uptime or error-free operation.":
      "Aucune garantie de disponibilité continue ni d’absence d’erreurs.",
    "Payments are processed through PayPal.":
      "Les paiements sont traités via PayPal.",
    "We do not store full payment details.":
      "Nous ne stockons pas les informations complètes de paiement.",
    "By making a purchase, you agree to PayPal’s terms and privacy policy.":
      "En effectuant un achat, vous acceptez les conditions et la politique de confidentialité de PayPal.",
    "Use of the Website is subject to our Privacy Policy.":
      "L’utilisation du Site est soumise à notre Politique de confidentialité.",
    "The service is provided “as is” and “as available”.":
      "Le service est fourni « en l’état » et « selon disponibilité ».",
    "We are not liable for indirect or consequential damages.":
      "Nous ne sommes pas responsables des dommages indirects ou consécutifs.",
    "Our total liability is limited to the amount you paid in the last 6 months.":
      "Notre responsabilité totale est limitée au montant que vous avez payé au cours des 6 derniers mois.",
    "These Terms are governed by the laws of Spain.":
      "Ces conditions sont régies par les lois de l’Espagne.",
    "Nothing limits your rights under applicable consumer laws.":
      "Rien ne limite vos droits en vertu des lois applicables sur la consommation.",
    "We may update these Terms at any time.":
      "Nous pouvons mettre à jour ces conditions à tout moment.",
    "This License Agreement (“Agreement”) governs the use of video templates and rendered videos available through CreaVideos.online (“CreaVideos”, “we”, “our”, or “us”).":
      "Ce Contrat de licence (« Contrat ») régit l’utilisation des modèles vidéo et des vidéos générées disponibles via CreaVideos.online (« CreaVideos », « nous », « notre » ou « nos »).",
    "By using the service and downloading or rendering videos, you agree to this Agreement.":
      "En utilisant le service et en téléchargeant ou générant des vidéos, vous acceptez ce Contrat.",
    "You are allowed to:": "Vous êtes autorisé à :",
    "You may NOT:": "Vous ne pouvez PAS :",
    "Your license is valid only while your subscription is active.":
      "Votre licence n’est valable que tant que votre abonnement est actif.",
    "Templates and videos are provided “as is”.":
      "Les modèles et vidéos sont fournis « en l’état ».",
    "Welcome to CreaVideos.online (“Website”), operated by CreaVideos – Renaud Jean Noel Pomies (“CreaVideos”, “we”, “our”, or “us”).":
      "Bienvenue sur CreaVideos.online (« Site »), exploité par CreaVideos – Renaud Jean Noel Pomies (« CreaVideos », « nous », « notre » ou « nos »).",
    "This Privacy Policy explains how we collect, use, disclose, and protect your personal data when you use our Website and services.":
      "Cette Politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos données personnelles lorsque vous utilisez notre Site et nos services.",
    "We comply with the General Data Protection Regulation (GDPR) and other applicable data protection laws.":
      "Nous respectons le Règlement général sur la protection des données (RGPD) et les autres lois applicables en matière de protection des données.",
    "We may collect the following categories of personal data:":
      "Nous pouvons collecter les catégories suivantes de données personnelles :",
    "Payments are processed via PayPal.":
      "Les paiements sont traités via PayPal.",
    "We use your data to:": "Nous utilisons vos données pour :",
    "We process your data under:": "Nous traitons vos données sur la base de :",
    "We use trusted third-party providers:":
      "Nous utilisons des prestataires tiers de confiance :",
    "We keep your data:": "Nous conservons vos données :",
    "You may request deletion at any time.":
      "Vous pouvez demander la suppression à tout moment.",
    "You have the right to:": "Vous avez le droit de :",
    "We implement appropriate security measures to protect your data.":
      "Nous mettons en place des mesures de sécurité appropriées pour protéger vos données.",
    "However, no system is 100% secure.":
      "Cependant, aucun système n’est sécurisé à 100 %.",
    "Your data may be processed outside the EU (e.g. PayPal, PixVerse).":
      "Vos données peuvent être traitées en dehors de l’UE (ex. PayPal, PixVerse).",
    "We may update this Privacy Policy.":
      "Nous pouvons mettre à jour cette Politique de confidentialité.",
    "4.2 Billing": "4.2 Facturation",
    "4.3 Automatic Renewal": "4.3 Renouvellement automatique",
    "4.5 Failed Payments": "4.5 Paiements échoués",
    "5.1 Cancellation": "5.1 Annulation",
    "5.2 Refund Policy": "5.2 Politique de remboursement",
    "5.3 Effect of Cancellation": "5.3 Effet de l’annulation",
    "You are granted a non-exclusive, non-transferable, non-sublicensable license.":
      "Une licence non exclusive, non transférable et non sous-licenciable vous est accordée.",
    "A. Standard License": "A. Licence standard",
    "Commercial use allowed": "Utilisation commerciale autorisée",
    "Up to 500,000 total views": "Jusqu’à 500 000 vues au total",
    "B. Enhanced License": "B. Licence étendue",
    "Required if:": "Obligatoire si :",
    "views exceed 500,000": "les vues dépassent 500 000",
    "used for TV, broadcast, or large-scale distribution":
      "utilisé pour la TV, la diffusion ou une distribution à grande échelle",
    "Contact:": "Contact :",
    "You may:": "Vous pouvez :",
    "customize templates,": "personnaliser les modèles,",
    "use rendered videos for your business or clients.":
      "utiliser les vidéos générées pour votre activité ou vos clients.",
    "resell or distribute templates,": "revendre ou distribuer les modèles,",
    "claim ownership of templates,": "revendiquer la propriété des modèles,",
    "build competing template platforms.":
      "créer des plateformes de modèles concurrentes.",
    "You confirm you have all rights to:":
      "Vous confirmez disposer de tous les droits sur :",
    "images,": "images,",
    "text,": "texte,",
    "logos.": "logos.",
    "You are responsible for compliance with laws and platform policies.":
      "Vous êtes responsable du respect des lois et des politiques des plateformes.",
    "violate laws,": "enfreindre les lois,",
    "infringe rights,": "porter atteinte aux droits,",
    "upload harmful content,": "téléverser du contenu nuisible,",
    "reverse engineer or scrape the service,":
      "rétroconcevoir ou scraper le service,",
    "bypass protections,": "contourner les protections,",
    "share accounts,": "partager des comptes,",
    "misuse templates.": "faire un mauvais usage des modèles.",
    "The Website may rely on third-party providers to deliver certain features.":
      "Le Site peut s’appuyer sur des prestataires tiers pour fournir certaines fonctionnalités.",
    "These include:": "Cela inclut :",
    "13.1 Payment Processing (PayPal)":
      "13.1 Traitement des paiements (PayPal)",
    "13.2 AI Video Generation (PixVerse)":
      "13.2 Génération vidéo IA (PixVerse)",
    "CreaVideos uses third-party AI services, including PixVerse, to generate videos from images.":
      "CreaVideos utilise des services d’IA tiers, dont PixVerse, pour générer des vidéos à partir d’images.",
    "By using these features, you acknowledge that:":
      "En utilisant ces fonctionnalités, vous reconnaissez que :",
    "your uploaded images, prompts, and content may be processed by PixVerse,":
      "vos images, prompts et contenus téléversés peuvent être traités par PixVerse,",
    "this processing is required to deliver the service,":
      "ce traitement est nécessaire pour fournir le service,",
    "CreaVideos is not responsible for the output generated by AI systems.":
      "CreaVideos n’est pas responsable des résultats générés par les systèmes d’IA.",
    "We may suspend or terminate your account if:":
      "Nous pouvons suspendre ou résilier votre compte si :",
    "you violate these Conditions,": "vous violez ces Conditions,",
    "payment fails,": "le paiement échoue,",
    "misuse occurs.": "un usage abusif est constaté.",
    "We do not guarantee:": "Nous ne garantissons pas :",
    "uninterrupted service,": "un service ininterrompu,",
    "error-free operation,": "un fonctionnement sans erreur,",
    "platform acceptance of your videos.":
      "l’acceptation de vos vidéos par les plateformes.",
    "You agree to indemnify CreaVideos for any claims resulting from:":
      "Vous acceptez d’indemniser CreaVideos pour toute réclamation résultant de :",
    "your use of the service,": "votre utilisation du service,",
    "your content,": "votre contenu,",
    "your violations of these Conditions.": "vos violations de ces Conditions.",
    "CreaVideos may allow users to connect accounts via Facebook or Instagram (“Meta Platforms”) for login, account linking, or sharing content.":
      "CreaVideos peut permettre aux utilisateurs de connecter des comptes via Facebook ou Instagram (« Plateformes Meta ») pour la connexion, la liaison de compte ou le partage de contenu.",
    "24.1 Data Access": "24.1 Accès aux données",
    "name,": "nom,",
    "email,": "e-mail,",
    "profile picture,": "photo de profil,",
    "account ID,": "ID de compte,",
    "other authorized data.": "autres données autorisées.",
    "24.2 Use of Data": "24.2 Utilisation des données",
    "authenticate users,": "authentifier les utilisateurs,",
    "enable login,": "permettre la connexion,",
    "allow sharing,": "permettre le partage,",
    "operate and improve the service.": "exploiter et améliorer le service.",
    "24.3 Posting Permissions": "24.3 Autorisations de publication",
    "24.4 Disconnection": "24.4 Déconnexion",
    "You may disconnect anytime via:":
      "Vous pouvez déconnecter à tout moment via :",
    "your CreaVideos account, or": "votre compte CreaVideos, ou",
    "24.5 Meta Compliance": "24.5 Conformité Meta",
    "Use must comply with Meta policies. We are not responsible for their platform changes.":
      "L’utilisation doit respecter les politiques de Meta. Nous ne sommes pas responsables des changements de leur plateforme.",
    "Subject to an active subscription and compliance with the Conditions of Service, CreaVideos grants you a:":
      "Sous réserve d’un abonnement actif et du respect des Conditions de service, CreaVideos vous accorde une :",
    "non-exclusive": "non exclusive",
    "non-transferable": "non transférable",
    "non-sublicensable": "non sous-licenciable",
    revocable: "révocable",
    "license to use videos created using our templates.":
      "licence d’utilisation des vidéos créées avec nos modèles.",
    "use rendered videos for commercial and personal purposes":
      "utiliser les vidéos générées à des fins commerciales et personnelles",
    "use videos for:": "utiliser les vidéos pour :",
    "social media (Instagram, Facebook, TikTok, etc.)":
      "réseaux sociaux (Instagram, Facebook, TikTok, etc.)",
    "websites and landing pages": "sites web et pages de destination",
    "digital advertising (Meta Ads, Google Ads, etc.)":
      "publicité digitale (Meta Ads, Google Ads, etc.)",
    "client work (if you are an agency or freelancer)":
      "travail client (si vous êtes une agence ou un freelance)",
    "You may modify templates only through the CreaVideos platform.":
      "Vous pouvez modifier les modèles uniquement via la plateforme CreaVideos.",
    "resell, sublicense, share, or distribute templates":
      "revendre, sous-licencier, partager ou distribuer des modèles",
    "provide templates as part of another platform or service":
      "fournir des modèles dans une autre plateforme ou un autre service",
    "redistribute templates in editable form":
      "redistribuer les modèles sous forme modifiable",
    "extract assets to build a competing template library":
      "extraire des ressources pour créer une bibliothèque de modèles concurrente",
    "use templates to create a competing SaaS or product":
      "utiliser les modèles pour créer un SaaS ou produit concurrent",
    "Standard License": "Licence standard",
    "Includes usage up to 500,000 total views":
      "Inclut une utilisation jusqu’à 500 000 vues au total",
    "Enhanced License Required": "Licence étendue requise",
    "You must contact us if:": "Vous devez nous contacter si :",
    "usage exceeds 500,000 views": "l’utilisation dépasse 500 000 vues",
    "videos are used for:": "les vidéos sont utilisées pour :",
    TV: "TV",
    cinema: "cinéma",
    "large-scale broadcast or streaming":
      "diffusion ou streaming à grande échelle",
    "All templates remain the property of CreaVideos":
      "Tous les modèles restent la propriété de CreaVideos",
    "You own the final rendered videos, subject to this license":
      "Vous possédez les vidéos finales générées, sous réserve de cette licence",
    "No ownership is transferred for templates or platform technology":
      "Aucune propriété n’est transférée pour les modèles ou la technologie de la plateforme",
    "You retain ownership of content you upload (images, videos, text).":
      "Vous conservez la propriété du contenu que vous téléversez (images, vidéos, texte).",
    "You grant us a limited license to:":
      "Vous nous accordez une licence limitée pour :",
    "process it": "le traiter",
    "render videos": "générer des vidéos",
    "operate the service": "exploiter le service",
    "You are responsible for ensuring you have the rights to use your content.":
      "Vous êtes responsable de vous assurer que vous avez les droits d’utiliser votre contenu.",
    "Videos may be generated using AI tools (e.g. PixVerse).":
      "Les vidéos peuvent être générées à l’aide d’outils d’IA (ex. PixVerse).",
    "You acknowledge:": "Vous reconnaissez :",
    "AI results may vary": "les résultats IA peuvent varier",
    "outputs may not be unique": "les résultats peuvent ne pas être uniques",
    "outputs may resemble other content":
      "les résultats peuvent ressembler à d’autres contenus",
    "CreaVideos does not guarantee:": "CreaVideos ne garantit pas :",
    uniqueness: "l’unicité",
    "copyright clearance": "la conformité aux droits d’auteur",
    "suitability for all uses": "l’adéquation à tous les usages",
    "After cancellation:": "Après annulation :",
    "you may continue using previously downloaded videos":
      "vous pouvez continuer à utiliser les vidéos déjà téléchargées",
    "you lose access to templates and editing tools":
      "vous perdez l’accès aux modèles et aux outils d’édition",
    "If you violate this Agreement:": "Si vous violez ce Contrat :",
    "your license may be revoked immediately":
      "votre licence peut être révoquée immédiatement",
    performance: "la performance",
    "legal suitability": "la conformité légale",
    "platform acceptance (ads, social media, etc.)":
      "l’acceptation par les plateformes (pubs, réseaux sociaux, etc.)",
    "CreaVideos is not liable for:": "CreaVideos n’est pas responsable de :",
    "misuse of videos": "l’usage abusif des vidéos",
    "copyright claims from user-uploaded content":
      "réclamations de droits d’auteur liées au contenu téléversé par l’utilisateur",
    "business losses": "pertes commerciales",
    "The data controller responsible for your personal data is:":
      "Le responsable du traitement de vos données personnelles est :",
    "2.1 Account Information": "2.1 Informations du compte",
    Name: "Nom",
    "E-mail address": "Adresse e-mail",
    "(encrypted)": "(chiffré)",
    "2.2 Payment Information": "2.2 Informations de paiement",
    "We may receive:": "Nous pouvons recevoir :",
    "payment confirmation": "confirmation de paiement",
    "subscription status": "statut d’abonnement",
    "transaction ID": "ID de transaction",
    "billing-related metadata": "métadonnées liées à la facturation",
    "2.3 User Content": "2.3 Contenu utilisateur",
    "Text entered into templates": "Texte saisi dans les modèles",
    "Images or videos uploaded": "Images ou vidéos téléversées",
    "Generated videos": "Vidéos générées",
    "2.4 Usage Data": "2.4 Données d’utilisation",
    "IP address": "Adresse IP",
    "browser type": "type de navigateur",
    "device information": "informations sur l’appareil",
    "pages visited": "pages visitées",
    "usage behavior": "comportement d’utilisation",
    "2.5 Meta (Facebook / Instagram) Data":
      "2.5 Données Meta (Facebook / Instagram)",
    "If you connect your account:": "Si vous connectez votre compte :",
    "permissions granted": "autorisations accordées",
    "provide and operate the service": "fournir et exploiter le service",
    "create and manage your account": "créer et gérer votre compte",
    "process subscriptions and payments":
      "traiter les abonnements et paiements",
    "allow video creation and rendering":
      "permettre la création et le rendu de vidéos",
    "enable social media sharing":
      "permettre le partage sur les réseaux sociaux",
    "communicate with you": "communiquer avec vous",
    "improve performance and features":
      "améliorer les performances et fonctionnalités",
    "comply with legal obligations": "respecter les obligations légales",
    "Contract → to provide the service": "Contrat → pour fournir le service",
    "Legitimate interest → to improve and secure the platform":
      "Intérêt légitime → pour améliorer et sécuriser la plateforme",
    "Consent → for optional features (e.g. Meta login)":
      "Consentement → pour les fonctionnalités optionnelles (ex. connexion Meta)",
    "Legal obligation → accounting, taxes":
      "Obligation légale → comptabilité, taxes",
    "If you connect via Meta:": "Si vous vous connectez via Meta :",
    "we only access data you approve":
      "nous accédons uniquement aux données que vous approuvez",
    "we use it for login and sharing":
      "nous les utilisons pour la connexion et le partage",
    "we never post without your action":
      "nous ne publions jamais sans votre action",
    "To enable these features, we may store limited Meta-related connection data such as account IDs, usernames, granted permission status, and access tokens needed to perform user-initiated sharing.":
      "Pour activer ces fonctionnalités, nous pouvons stocker des données de connexion Meta limitées telles que les identifiants de compte, noms d’utilisateur, statut des autorisations accordées et jetons d’accès nécessaires pour effectuer des partages initiés par l’utilisateur.",
    "We disclose Meta-related data only to Meta Platforms as required to authenticate your account and process your explicit sharing requests. We do not sell this data or use it for independent advertising.":
      "Nous divulguons les données liées à Meta uniquement à Meta Platforms lorsque cela est nécessaire pour authentifier votre compte et traiter vos demandes explicites de partage. Nous ne vendons pas ces données et ne les utilisons pas pour de la publicité indépendante.",
    "You can disconnect anytime via:":
      "Vous pouvez déconnecter à tout moment via :",
    "your account settings": "les paramètres de votre compte",
    "6.1 PayPal (Payments)": "6.1 PayPal (Paiements)",
    "Used to process subscriptions securely.":
      "Utilisé pour traiter les abonnements de façon sécurisée.",
    "PayPal acts as an independent data controller.":
      "PayPal agit en tant que responsable du traitement indépendant.",
    "Their privacy policy applies to payment data.":
      "Leur politique de confidentialité s’applique aux données de paiement.",
    "6.2 PixVerse (AI Video Generation)": "6.2 PixVerse (Génération vidéo IA)",
    "This means:": "Cela signifie :",
    "images and prompts you submit may be processed by PixVerse":
      "les images et prompts que vous soumettez peuvent être traités par PixVerse",
    "processing is necessary to deliver the service":
      "ce traitement est nécessaire pour fournir le service",
    "We only send required data.":
      "Nous n’envoyons que les données nécessaires.",
    "6.3 Google / YouTube (OAuth and YouTube upload)":
      "6.3 Google / YouTube (OAuth et téléversement YouTube)",
    "If you connect YouTube, we use Google OAuth and YouTube API services to authenticate your account and upload videos only when you request sharing.":
      "Si vous connectez YouTube, nous utilisons Google OAuth et les services API YouTube pour authentifier votre compte et téléverser des vidéos uniquement lorsque vous demandez un partage.",
    "For this integration:": "Pour cette intégration :",
    "we may receive your Google account basic profile/channel information and OAuth tokens":
      "nous pouvons recevoir les informations de profil/de chaîne de base de votre compte Google ainsi que des jetons OAuth",
    "we use this data only to maintain the connection and perform user-initiated YouTube uploads":
      "nous utilisons ces données uniquement pour maintenir la connexion et effectuer des téléversements YouTube initiés par l’utilisateur",
    "we do not transfer Google user data to third parties except as required to provide this feature":
      "nous ne transférons pas les données utilisateur Google à des tiers, sauf lorsque cela est nécessaire pour fournir cette fonctionnalité",
    "6.4 TikTok (OAuth and upload-to-TikTok flow)":
      "6.4 TikTok (OAuth et flux de téléversement vers TikTok)",
    "If you connect TikTok, we use TikTok OAuth and upload APIs to send your rendered video to TikTok when you choose to share.":
      "Si vous connectez TikTok, nous utilisons TikTok OAuth et les API de téléversement pour envoyer votre vidéo rendue à TikTok lorsque vous choisissez de la partager.",
    "Posting is user-controlled: after upload, you may need to finish publishing inside TikTok.":
      "La publication est contrôlée par l’utilisateur : après le téléversement, vous devrez peut-être finaliser la publication dans TikTok.",
    "while your account is active": "tant que votre compte est actif",
    "as needed for legal obligations (e.g. accounting)":
      "si nécessaire pour les obligations légales (ex. comptabilité)",
    "If you want CreaVideos to delete your data, please follow these steps:":
      "Si vous souhaitez que CreaVideos supprime vos données, veuillez suivre ces étapes :",
    "Send an email to reno@creavideos.online with the subject line":
      "Envoyez un e-mail à reno@creavideos.online avec l’objet",
    "Include the email address linked to your CreaVideos account and, if applicable, your Facebook/Instagram account ID.":
      "Incluez l’adresse e-mail liée à votre compte CreaVideos et, le cas échéant, l’ID de votre compte Facebook/Instagram.",
    "We may ask for verification to confirm account ownership before processing your request.":
      "Nous pouvons demander une vérification pour confirmer la propriété du compte avant de traiter votre demande.",
    "After verification, we will delete or anonymize eligible personal data within a reasonable period, except for information we must keep for legal, fraud-prevention, or accounting purposes.":
      "Après vérification, nous supprimerons ou anonymiserons les données personnelles éligibles dans un délai raisonnable, sauf les informations que nous devons conserver pour des raisons légales, de prévention de la fraude ou de comptabilité.",
    "access your data": "accéder à vos données",
    "correct your data": "corriger vos données",
    "delete your data (“right to be forgotten”)":
      "supprimer vos données (« droit à l’oubli »)",
    "restrict processing": "limiter le traitement",
    "object to processing": "vous opposer au traitement",
    "data portability": "portabilité des données",
    "To exercise your rights:": "Pour exercer vos droits :",
    "You also have the right to file a complaint with a supervisory authority in the EU.":
      "Vous avez également le droit de déposer une plainte auprès d’une autorité de contrôle dans l’UE.",
    "When this happens, we ensure appropriate safeguards (e.g. standard contractual clauses).":
      "Dans ce cas, nous veillons à des garanties appropriées (ex. clauses contractuelles types).",
    "CreaVideos uses cookies and similar technologies to ensure the proper functioning of the Website and to provide essential features.":
      "CreaVideos utilise des cookies et technologies similaires pour assurer le bon fonctionnement du Site et fournir des fonctionnalités essentielles.",
    "Cookies are small text files stored on your device when you visit a website. They help websites function correctly and improve user experience.":
      "Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez un site web. Ils aident les sites à fonctionner correctement et améliorent l’expérience utilisateur.",
    "We currently use only cookies and similar technologies that are strictly necessary for the operation of the Website.":
      "Nous utilisons actuellement uniquement des cookies et technologies similaires strictement nécessaires au fonctionnement du Site.",
    "To allow you to log in, stay logged in, and securely access your account.":
      "Pour vous permettre de vous connecter, de rester connecté et d’accéder en toute sécurité à votre compte.",
    "To protect against fraudulent activity and ensure the security of the Website.":
      "Pour protéger contre les activités frauduleuses et assurer la sécurité du Site.",
    "To enable secure payment processing through our payment provider (PayPal).":
      "Pour permettre un traitement sécurisé des paiements via notre prestataire de paiement (PayPal).",
    "To allow you to connect your account and share videos to platforms such as Facebook and Instagram when you choose to do so.":
      "Pour vous permettre de connecter votre compte et de partager des vidéos sur des plateformes comme Facebook et Instagram lorsque vous le choisissez.",
    "These cookies are essential for providing the services you request and cannot be disabled without affecting the functionality of the Website.":
      "Ces cookies sont essentiels pour fournir les services que vous demandez et ne peuvent pas être désactivés sans affecter le fonctionnement du Site.",
    "CreaVideos does not currently use analytics, advertising, or tracking cookies.":
      "CreaVideos n’utilise actuellement pas de cookies d’analyse, de publicité ou de suivi.",
    "We do not track your browsing behavior for marketing purposes and do not use third-party tracking tools such as advertising pixels.":
      "Nous ne suivons pas votre navigation à des fins marketing et n’utilisons pas d’outils de suivi tiers tels que les pixels publicitaires.",
    "Some essential features rely on trusted third-party providers, including:":
      "Certaines fonctionnalités essentielles reposent sur des prestataires tiers de confiance, notamment :",
    "PayPal for payment processing": "PayPal pour le traitement des paiements",
    "Meta Platforms (Facebook / Instagram) for login and sharing features":
      "Meta Platforms (Facebook / Instagram) pour les fonctionnalités de connexion et de partage",
    "These providers may use their own cookies or similar technologies as part of the services they provide. Their use of data is governed by their respective privacy policies.":
      "Ces prestataires peuvent utiliser leurs propres cookies ou technologies similaires dans le cadre de leurs services. Leur utilisation des données est régie par leurs politiques de confidentialité respectives.",
    "If we introduce analytics or marketing cookies in the future, we will update this section and implement a cookie consent mechanism allowing you to manage your preferences.":
      "Si nous introduisons des cookies d’analyse ou marketing à l’avenir, nous mettrons à jour cette section et mettrons en place un mécanisme de consentement vous permettant de gérer vos préférences.",
    "Your photo posts don't reach new clients.":
      "Vos publications photo n’atteignent pas de nouveaux clients.",
    "Turn the photos you already post into videos and reach more people without having to create more content.":
      "Transformez les photos que vous publiez déjà en vidéos et touchez plus de personnes sans avoir à créer plus de contenu.",
    "With CreaVideos, turn your photos into short social media videos in about 2 minutes and publish them directly to all your social platforms with just one click.":
      "Avec CreaVideos, transformez vos photos en courtes vidéos pour les réseaux sociaux en environ 2 minutes et publiez-les directement sur toutes vos plateformes sociales en un seul clic.",
    "Start your first month for ": "Commencez votre premier mois pour ",
    " instead of ": " au lieu de ",
    "Plans from ": "Offres à partir de ",
    "/month after your first month. Cancel anytime.":
      "/mois après votre premier mois. Résiliez à tout moment.",
    "Why post a photo when you can post a video?":
      "Pourquoi publier une photo quand vous pouvez publier une vidéo ?",
    "Videos are pushed to people who don't follow you, while image posts are only seen by your existing followers.":
      "Les vidéos sont montrées à des personnes qui ne vous suivent pas, tandis que les publications avec photo ne sont vues que par vos abonnés actuels.",
    "You know you need to post videos regularly. But they take time and money.":
      "Vous savez que vous devez publier régulièrement des vidéos. Mais elles demandent du temps et de l’argent.",
    "Ideally, you should post 3 or 4 videos every week to reach new people.":
      "Idéalement, vous devriez publier 3 ou 4 vidéos par semaine pour toucher de nouvelles personnes.",
    "But filming and professionally editing that many videos every week quickly becomes too expensive for most small businesses.":
      "Mais filmer et monter professionnellement autant de vidéos chaque semaine devient vite trop coûteux pour la plupart des petites entreprises.",
    "So what happens?": "Alors, que se passe-t-il ?",
    "You post pictures instead.": "Vous publiez des photos à la place.",
    "They're quick, they're easy, and you already have them.":
      "C’est rapide, facile, et vous les avez déjà.",
    "CreaVideos was created to make turning those same pictures into videos almost as easy as posting the picture itself.":
      "CreaVideos a été créé pour rendre la transformation de ces mêmes photos en vidéos presque aussi simple que la publication de la photo elle-même.",
    "Don't change what you post. Change how you post it.":
      "Ne changez pas ce que vous publiez. Changez la façon de le publier.",
    "What you do now": "Ce que vous faites actuellement",
    "Take a photo → Write a caption → Publish":
      "Prendre une photo → Écrire une légende → Publier",
    "With CreaVideos": "Avec CreaVideos",
    "Take the same photo → Choose a template → Edit the text → Publish a video":
      "Prendre la même photo → Choisir un modèle → Modifier le texte → Publier une vidéo",
    "Just 2 extra minutes.": "Seulement 2 minutes de plus.",
    "Instead of publishing a photo, you're publishing a video that will be shown to people who don't follow you.":
      "Au lieu de publier une photo, vous publiez une vidéo qui sera montrée à des personnes qui ne vous suivent pas.",
    "You're not creating new content. You're simply turning the content you already create into videos.":
      "Vous ne créez pas de nouveau contenu. Vous transformez simplement en vidéos le contenu que vous créez déjà.",
    "Same content. More reach.": "Même contenu. Plus de portée.",
    "And there's another advantage.": "Et il y a un autre avantage.",
    "Because your content is now a video, you can also publish it on TikTok. Many businesses don't post on TikTok because they only create photo posts.":
      "Comme votre contenu est désormais une vidéo, vous pouvez aussi le publier sur TikTok. De nombreuses entreprises n’y publient pas parce qu’elles ne créent que des publications photo.",
    "With CreaVideos you can connect to your Instagram, Facebook, TikTok and YouTube accounts and share the video on all 4 platforms with just one click.":
      "Avec CreaVideos, connectez vos comptes Instagram, Facebook, TikTok et YouTube et partagez la vidéo sur les 4 plateformes en un seul clic.",
    "If you post regularly on social media and want an easier, faster way to create short videos, CreaVideos is for you. No video editing experience needed.":
      "Si vous publiez régulièrement sur les réseaux sociaux et souhaitez créer des vidéos courtes plus facilement et plus rapidement, CreaVideos est fait pour vous. Aucune expérience en montage vidéo n’est nécessaire.",
    "Real estate agents showcasing properties":
      "Agents immobiliers présentant des biens",
    "Any business posting on social media":
      "Toute entreprise publiant sur les réseaux sociaux",
    "Don't post the same kind of video every day":
      "Ne publiez pas le même type de vidéo chaque jour",
    "CreaVideos gives you different ways to turn your everyday content into videos, so your social media stays fresh and varied.":
      "CreaVideos vous offre différentes façons de transformer votre contenu quotidien en vidéos, pour des réseaux sociaux toujours frais et variés.",
    "AI Image-to-Video": "Image vers vidéo par IA",
    "Turn a photo into a moving video.":
      "Transformez une photo en vidéo animée.",
    "Simple & Visual Templates": "Modèles simples et visuels",
    "Turn your photos into animated slideshows.":
      "Transformez vos photos en diaporamas animés.",
    "Edited Video Templates": "Modèles de vidéos montées",
    "Upload your clips and let CreaVideos do the editing.":
      "Importez vos clips et laissez CreaVideos faire le montage.",
    "Fun & Creative Videos": "Vidéos amusantes et créatives",
    "Create entertaining posts and ads with actors.":
      "Créez des publications et publicités divertissantes avec des acteurs.",
    "Client Review Videos": "Vidéos d’avis clients",
    "Collect authentic customer testimonials with a QR code.":
      "Recueillez d’authentiques témoignages clients avec un code QR.",
    "Five types of videos. So your posts never get repetitive.":
      "Cinq types de vidéos, pour que vos publications ne soient jamais répétitives.",
    "Turn your photos into professional-looking social media videos.":
      "Transformez vos photos en vidéos professionnelles pour les réseaux sociaux.",
    "Nothing beats a professional video":
      "Rien ne vaut une vidéo professionnelle",
    "Professionally filmed and edited videos are one of the best ways to promote your business on social media.":
      "Les vidéos filmées et montées par des professionnels sont l’un des meilleurs moyens de promouvoir votre entreprise sur les réseaux sociaux.",
    "If you have the budget, you should absolutely create them.":
      "Si vous en avez le budget, vous devriez absolument en créer.",
    "CreaVideos isn't here to replace that.":
      "CreaVideos n’est pas là pour les remplacer.",
    "It's here for all those other posts where you would normally publish a picture.":
      "Il est là pour toutes ces autres publications où vous publieriez normalement une photo.",
    "Instead of photo post, spend two extra minutes and turn it into a video that will be shown to non followers.":
      "Au lieu de publier une photo, prenez deux minutes de plus et transformez-la en une vidéo qui sera montrée à des personnes qui ne vous suivent pas.",
    "Post videos regularly without the professional-video budget":
      "Publiez régulièrement des vidéos sans le budget d’une production professionnelle",
    "Create up to 16 videos every month.": "Créez jusqu’à 16 vidéos par mois.",
    "That's enough to publish ": "C’est suffisant pour publier ",
    "4 videos every week.": "4 vidéos par semaine.",
    "Starting from about ": "À partir d’environ ",
    " per video.": " par vidéo.",
    "Plans start at ": "Les offres commencent à ",
    "You're already creating the content.": "Vous créez déjà le contenu.",
    "You're already taking the photos.": "Vous prenez déjà les photos.",
    "You're already writing the captions.": "Vous écrivez déjà les légendes.",
    "Now spend just two extra minutes...":
      "Maintenant, prenez seulement deux minutes de plus…",
    "and publish videos instead.": "et publiez plutôt des vidéos.",
    "So... what's your excuse for not posting videos more often?":
      "Alors… quelle est votre excuse pour ne pas publier plus souvent des vidéos ?",
  },
  es: {
    Privacy: "Privacidad",
    Public: "Público",
    Unlisted: "No listado",
    Private: "Privado",
    Scene: "Escena",
    "Scene {number}": "Escena {number}",
    Duration: "Duración",
    "Scene {number} media": "Contenido multimedia de la escena {number}",
    "Select to upload media": "Subir contenido multimedia",
    "Media uploaded": "Contenido multimedia subido",
    "Add Text": "Añadir Texto",
    "Add Shape": "Añadir Forma",
    "Add scene": "Añadir Escena",
    "Delete Scene {number}": "Eliminar escena {number}",
    "Duration follows the uploaded video": "La duración sigue la del video subido",
    "Scene duration": "Duración de la escena",
    "Custom video scenes": "Escenas de video personalizadas",
    "Video clips set each scene's duration automatically.":
      "Los clips de video establecen automáticamente la duración de cada escena.",
    "Questions? Chat with us": "¿Preguntas? Chatea con nosotros",
    Shape: "Forma",
    "Shape Settings": "Ajustes de forma",
    "Square / Rectangle": "Cuadrado / Rectángulo",
    "Circle / Oval": "Círculo / Óvalo",
    "Shape Styling": "Estilo de la forma",
    "Background Color": "Color de fondo",
    "Background Opacity": "Opacidad del fondo",
    "Border Color": "Color del borde",
    "Border Width (px)": "Ancho del borde (px)",
    "X Position (%)": "Posición X (%)",
    "Y Position (%)": "Posición Y (%)",
    "Width (%)": "Ancho (%)",
    "Height (%)": "Alto (%)",
    Scale: "Escala",
    "Rotation (°)": "Rotación (°)",
    "Layer Opacity": "Opacidad de la capa",
    "Corner Position Offsets (%)": "Desplazamientos de posición de las esquinas (%)",
    "Offsets are relative to the shape's width and height. Positive Y moves a corner down.":
      "Los desplazamientos son relativos al ancho y al alto de la forma. Un valor Y positivo mueve una esquina hacia abajo.",
    "Shape Corner Radius (px)": "Radio de las esquinas de la forma (px)",
    "All corners": "Todas las esquinas",
    "Top left": "Superior izquierda",
    "Top right": "Superior derecha",
    "Bottom right": "Inferior derecha",
    "Bottom left": "Inferior izquierda",
    "Client review recording page settings":
      "Configuración de la página de grabación de reseñas de clientes",
    "Customize the public page your clients use to record video reviews, then share the link or download the printable QR page.":
      "Personaliza la página pública que tus clientes usan para grabar reseñas en video; luego comparte el enlace o descarga la página QR imprimible.",
    "Upload your logo (optional)": "Sube tu logotipo (opcional)",
    "Name of the establishment/company/place":
      "Nombre del establecimiento/empresa/lugar",
    "Text for the review recording page":
      "Texto de la página de grabación de reseñas",
    "Text above the QR code": "Texto encima del código QR",
    "Save client review settings":
      "Guardar configuración de reseñas de clientes",
    "Open recording page": "Abrir página de grabación",
    Record: "Grabar",
    "Max duration: 30s": "Duración máxima: 30 s",
    "Client Review Draft": "Borrador de reseña de cliente",
    "Client review tools": "Herramientas de reseñas de clientes",
    Position: "Posición",
    "Adjust position": "Ajustar posición",
    "Width %": "Ancho %",
    "Height %": "Alto %",
    Top: "Arriba",
    Middle: "Centro",
    Bottom: "Abajo",
    "Client review video": "Video de reseña de cliente",
    "Trim recorded video": "Recortar video grabado",
    "Remove from beginning (seconds)": "Eliminar del inicio (segundos)",
    "Remove from end (seconds)": "Eliminar del final (segundos)",
    "Example: use 1.0 to remove the first second while the client adjusts their phone.":
      "Ejemplo: usa 1,0 para eliminar el primer segundo mientras el cliente ajusta su teléfono.",
    "Optional logo": "Logotipo opcional",
    "Upload optional logo": "Subir logotipo opcional",
    "Optional. If no logo is uploaded, nothing will appear in the final video. Uploaded logos are limited to the top-right 150px area.":
      "Opcional. Si no se sube ningún logotipo, no aparecerá nada en el video final. Los logotipos subidos están limitados al área superior derecha de 150 px.",
    "Optional caption": "Texto opcional",
    "Optional. Maximum 2 lines; leave empty to hide this text.":
      "Opcional. Máximo 2 líneas; déjalo vacío para ocultar este texto.",
    "Share to social media": "Compartir en redes sociales",
    "Create your first video": "Crea tu primer video",
    "View pricing": "Ver precios",
    Templates: "Plantillas",
    Pricing: "Precios",
    "Please fill all required fields. VAT is optional.":
      "Por favor completa todos los campos obligatorios. El IVA es opcional.",
    "Payment failed. Please try again.": "El pago falló. Inténtalo de nuevo.",
    "VAT check service is temporarily unavailable. VAT was applied by default.":
      "El servicio de validación de IVA no está disponible temporalmente. Se aplicó IVA por defecto.",
    "Valid VAT number detected. VAT not applied.":
      "Se detectó un número de IVA válido. No se aplicó IVA.",
    "VAT number not valid.": "Número de IVA no válido.",
    "Spanish VAT numbers (ES) still include 21% VAT.":
      "Los números de IVA españoles (ES) siguen incluyendo 21% de IVA.",
    "21% VAT applied.": "IVA del 21% aplicado.",
    "21% VAT is added when applicable.":
      "Se añade IVA del 21% cuando corresponde.",
    "Export started!": "¡La exportación ha comenzado!",
    "Failed to start export": "No se pudo iniciar la exportación",
    "You reached your monthly export limit. Upgrade your plan or buy extra video exports.":
      "Has alcanzado tu límite mensual de exportaciones. Mejora tu plan o compra exportaciones adicionales.",
    Category: "Categoría",
    Language: "Idioma",
    English: "Inglés",
    French: "Francés",
    Spanish: "Español",
    "Simple & Visual video templates": "Plantillas de video simples y visuales",
    "Fun & Creative video templates":
      "Plantillas de video divertidas y creativas",
    "Transform Image to video with AI": "Transformar imagen en video con IA",
    "Turn any static image into a ready-to-post video. These templates already include optimized AI prompts, so you just upload your image, click “Generate Video,” then edit or remove the text before exporting and sharing.":
      "Convierte cualquier imagen estática en un video listo para publicar. Estas plantillas ya incluyen prompts de IA optimizados, así que solo subes tu imagen, haces clic en «Generar video» y luego editas o eliminas el texto antes de exportar y compartir.",
    "Instead of posting an image, turn it into an engaging video post. Whether it’s a single photo or a 4-image slideshow, these templates add smooth animations and text to help your posts reach more people.":
      "En lugar de publicar una imagen, conviértela en una publicación de video atractiva. Ya sea una sola foto o una presentación de 4 imágenes, estas plantillas añaden animaciones fluidas y texto para ayudar a que tus publicaciones lleguen a más personas.",
    "Grab attention with short, humorous videos featuring an actor in everyday situations. Perfect for ads or posts that feel like mini-stories and make your audience smile.":
      "Capta la atención con videos cortos y humorísticos protagonizados por un actor en situaciones cotidianas. Perfectos para anuncios o publicaciones que se sienten como mini-historias y hacen sonreír a tu audiencia.",
    "Subscription activated successfully!": "¡Suscripción activada con éxito!",
    "Unable to save your information.": "No se pudo guardar tu información.",
    "Unable to create account.": "No se pudo crear la cuenta.",
    "PayPal is not configured yet. Please try again in a few minutes.":
      "PayPal aún no está configurado. Inténtalo de nuevo en unos minutos.",
    "Media uploaded successfully": "Contenido subido correctamente",
    "Failed to upload media": "Error al subir el contenido",
    "Media removed": "Contenido eliminado",
    "Begin uploaded video at (seconds)":
      "Comenzar el video subido en (segundos)",
    "Your uploaded video is": "Tu video subido dura",
    "and the layer is": "y la capa dura",
    "Move forward to show a specific portion inside this layer.":
      "Avanza en el video para mostrar una parte específica dentro de esta capa.",
    "Move the uploaded video forward to choose which part appears inside this layer.":
      "Avanza en el video subido para elegir qué parte aparece dentro de esta capa.",
    "No AI prompt configured for this layer":
      "No hay prompt de IA configurado para esta capa",
    "Please upload an image first": "Por favor sube una imagen primero",
    "Generating AI video...": "Generando video con IA...",
    "AI video ready, replaced the image in this layer":
      "Video de IA listo, se reemplazó la imagen en esta capa",
    "Timed out waiting for PixVerse video":
      "Tiempo de espera agotado al esperar el video de PixVerse",
    "AI generation failed": "La generación con IA falló",
    "Videos get more reach than images on social media":
      "Los videos consiguen más alcance que las fotos en redes sociales",
    "Your posts aren’t reaching new clients. Here’s why.":
      "Tus publicaciones no están llegando a nuevos clientes. Aquí tienes el motivo.",
    "Image posts are shown mostly to your followers. Videos get pushed to people who don’t follow you.":
      "Las publicaciones con imagen se muestran principalmente a tus seguidores. Los videos se muestran a personas que no te siguen.",
    "Turn your images into videos in 2 minutes with our templates, and publish to all your social platforms in just one click.":
      "Convierte tus imágenes en videos en 2 minutos con nuestras plantillas y publícalos en todas tus redes sociales con un solo clic.",
    "Reach new clients by posting videos instead of images":
      "Llega a nuevos clientes publicando vídeos en vez de fotos",
    "From just 1€ per video • 50% OFF first month":
      "Desde solo 1 € por video • 50 % de descuento el primer mes",
    "Tap video to play": "Toca el video para reproducirlo",
    "Creating videos takes time and money":
      "Crear videos requiere tiempo y dinero",
    "If you have the budget to create professional videos, or the time to film and edit videos yourself, quality content is one of the best ways to attract new followers and reach new clients.":
      "Si tienes presupuesto para crear videos profesionales, o tiempo para grabar y editar tú mismo, el contenido de calidad es una de las mejores formas de atraer nuevos seguidores y llegar a nuevos clientes.",
    "The problem is consistency.": "El problema es la constancia.",
    "Most small businesses cannot afford to create professional videos every day, or even several times per week. And business owners who create content themselves usually do not have hours to spend filming, editing and exporting videos.":
      "La mayoría de los pequeños negocios no puede permitirse crear videos profesionales todos los días, ni siquiera varias veces por semana. Y los dueños que crean contenido por su cuenta normalmente no tienen horas para grabar, editar y exportar videos.",
    "That is why we built CreaVideos.": "Por eso creamos CreaVideos.",
    "The idea was simple: make it possible to create videos in minutes, without editing skills, without expensive production costs, and without spending hours in front of editing software.":
      "La idea era simple: hacer posible crear videos en minutos, sin habilidades de edición, sin costes de producción caros y sin pasar horas frente a un programa de edición.",
    "Even if you already create professional videos for your business, CreaVideos can help you keep posting video content on the days where you would normally post images.":
      "Incluso si ya creas videos profesionales para tu negocio, CreaVideos puede ayudarte a seguir publicando contenido en video en los días en que normalmente publicarías imágenes.",
    "Instead of publishing fewer videos because of time or budget, you can keep showing your business regularly with videos that take only minutes to create.":
      "En lugar de publicar menos videos por falta de tiempo o presupuesto, puedes seguir mostrando tu negocio con regularidad con videos que solo tardan minutos en crearse.",
    "Perfect for small businesses": "Perfecto para pequeños negocios",
    "If you post on social media and need a tool to help you create short videos faster, this is for you:":
      "Si publicas en redes sociales y necesitas una herramienta que te ayude a crear videos cortos más rápido, esto es para ti:",
    "Reach new clients for less than 1€ per post":
      "Llega a nuevos clientes por menos de 1 € por publicación",
    "No agency. No editing. No expensive tools.":
      "Sin agencia. Sin edición. Sin herramientas caras.",
    "Just simple videos that help you get more visibility.":
      "Solo videos simples que te ayudan a tener más visibilidad.",
    "See what you can create": "Mira lo que puedes crear",
    "Professional-looking videos made from simple images":
      "Videos de aspecto profesional creados desde imágenes simples",
    "Start reaching new clients with your video posts":
      "Empieza a llegar a nuevos clientes con tus publicaciones en video",
    "Turn your images into videos and start reaching new clients today.":
      "Convierte tus imágenes en videos y empieza a llegar a nuevos clientes hoy.",
    Terms: "Términos",
    Privacy: "Privacidad",
    "Data Deletion": "Eliminación de datos",
    Support: "Soporte",
    "© 2025 CreaVideos. All rights reserved.":
      "© 2025 CreaVideos. Todos los derechos reservados.",
    "Choose a template": "Elige una plantilla",
    "Upload your images or clips": "Sube tus imágenes o clips",
    "And even if you already know how to edit videos, CreaVideos can save you time.":
      "Y aunque ya sepas editar videos, CreaVideos puede ahorrarte tiempo.",
    "You don't need to spend time editing on a timeline, export files and upload content to every platform one by one.":
      "No necesitas pasar tiempo editando en una línea de tiempo, exportando archivos y subiendo contenido a cada plataforma una por una.",
    "With our templates, your video can be ready in about 2 minutes, and published to all your social platforms in just one click. (Facebook, Instagram, Youtube and TikTok).":
      "Con nuestras plantillas, tu video puede estar listo en unos 2 minutos y publicarse en todas tus redes sociales con un solo clic. (Facebook, Instagram, Youtube y TikTok).",
    "The goal is not to replace professional video production.":
      "El objetivo no es reemplazar la producción de video profesional.",
    "It is to make posting videos regularly simple enough that any business can do it.":
      "Es hacer que publicar videos con regularidad sea lo bastante simple como para que cualquier negocio pueda hacerlo.",
    "Because the more regularly you post videos, the more chances you have to reach people who are not already following your page and keep attracting new potential clients.":
      "Porque cuanto más regularmente publiques videos, más posibilidades tendrás de llegar a personas que aún no siguen tu página y de seguir atrayendo nuevos clientes potenciales.",
    "quality content is one of the best ways to attract new followers and reach new clients":
      "el contenido de calidad es una de las mejores formas de atraer nuevos seguidores y llegar a nuevos clientes",
    "That is why we built CreaVideos": "Por eso creamos CreaVideos",
    "make it possible to create videos in minutes, without editing skills":
      "hacer posible crear videos en minutos, sin habilidades de edición",
    "CreaVideos can help you keep posting video content on the days where you would normally post images":
      "CreaVideos puede ayudarte a seguir publicando contenido en video en los días en que normalmente publicarías imágenes",
    "you can keep showing your business regularly with videos":
      "puedes seguir mostrando tu negocio con regularidad con videos",
    "CreaVideos can save you time": "CreaVideos puede ahorrarte tiempo",
    "ready in about 2 minutes, and published to all your social platforms in just one click":
      "listo en unos 2 minutos y publicado en todas tus redes sociales con un solo clic",
    "to make posting videos regularly simple":
      "hacer que publicar videos con regularidad sea simple",
    "reach people who are not already following your page and keep attracting new potential clients":
      "llegar a personas que aún no siguen tu página y seguir atrayendo nuevos clientes potenciales",
    "Customize your text": "Personaliza tu texto",
    "Download or share your video": "Descarga o comparte tu video",
    "Reach new clients": "Llega a nuevos clientes",
    "Your videos are pushed beyond your followers":
      "Tus videos se muestran más allá de tus seguidores",
    "Create in minutes": "Crea en minutos",
    "No learning curve, no editing skills needed":
      "Sin curva de aprendizaje, no necesitas edición",
    Affordable: "Asequible",
    "From less than 1€ per video": "Desde menos de 1 € por video",
    "Made for social media": "Hecho para redes sociales",
    "Perfect format for Instagram & Facebook":
      "Formato perfecto para Instagram y Facebook",
    "Reuse your content": "Reutiliza tu contenido",
    "Turn your existing images into videos":
      "Convierte tus imágenes existentes en videos",
    "Restaurants promoting dishes or menus":
      "Restaurantes promocionando platos o menús",
    "Real estate listings": "Anuncios inmobiliarios",
    "Local shops announcing products and offers":
      "Tiendas locales anunciando productos y ofertas",
    "Beauty & fitness services": "Servicios de belleza y fitness",
    "Any business posting on Instagram or Facebook":
      "Cualquier negocio que publique en Instagram o Facebook",
    "Plans from 19€/month": "Planes desde 19 €/mes",
    "Up to 100 videos/month": "Hasta 100 videos/mes",
    "Cancel anytime": "Cancela cuando quieras",
    "AI image to video generation": "Generar video con IA desde foto",
    "image with movement/slideshows": "imagen con movimiento/diapositivas",
    "Fun & Creative videos": "Videos divertidos y creativos",
    "Simple, transparent pricing": "Precios simples y transparentes",
    "Every plan starts with a 50% discounted first month, then renews monthly.":
      "Cada plan comienza con un primer mes con 50% de descuento y luego se renueva mensualmente.",
    "Most Popular": "Más popular",
    "Extra video packs": "Paquetes de videos extra",
    "Need more exports this month? Add extra videos instantly.":
      "¿Necesitas más exportaciones este mes? Agrega videos extra al instante.",
    "Temporary test plans": "Planes de prueba temporales",
    "For renewal verification only. This can be removed after testing.":
      "Solo para verificación de renovación. Puede eliminarse después de las pruebas.",
    "Frequently asked questions": "Preguntas frecuentes",
    "Can I change plans later?": "¿Puedo cambiar de plan después?",
    "What payment methods do you accept?": "¿Qué métodos de pago aceptan?",
    "Do unused exports roll over?": "¿Las exportaciones no usadas se acumulan?",
    "Can I cancel anytime?": "¿Puedo cancelar cuando quiera?",
    "Welcome back,": "Bienvenido de nuevo,",
    "Create and manage your video projects":
      "Crea y gestiona tus proyectos de video",
    "Exports Used": "Exportaciones usadas",
    "Videos Rendered": "Videos renderizados",
    "Current Plan": "Plan actual",
    "Recent Renders": "Renderizados recientes",
    "Create New Video": "Crear nuevo video",
    "My Account": "Mi cuenta",
    "My Subscription": "Mi suscripción",
    "View all": "Ver todo",
    Completed: "Completados",
    Download: "Descargar",
    "No renders yet": "Aún no hay renderizados",
    "Start by selecting a template and creating your first video":
      "Empieza seleccionando una plantilla y creando tu primer video",
    "Popular Templates": "Plantillas populares",
    "Terms of Service": "Términos del servicio",
    "License Agreement": "Acuerdo de licencia",
    "Privacy Policy": "Política de privacidad",
    "Last updated:": "Última actualización:",
    "Start for €": "Empieza por",
    "(50% OFF first month)": "(50% de descuento el primer mes)",
    "Current Plan": "Plan actual",
    Login: "Iniciar sesión",
    Subscribe: "Suscribirse",
    "You must subscribe or login to edit this template.":
      "Debes suscribirte o iniciar sesión para editar esta plantilla.",
    Buy: "Comprar",
    "Subscribe to": "Suscribirse a",
    "First month": "Primer mes",
    "PayPal is temporarily unavailable. Please try again in a few minutes.":
      "PayPal no está disponible temporalmente. Inténtalo de nuevo en unos minutos.",
    "Buy +": "Comprar +",
    "Extra videos pack": "Paquete de videos extra",
    "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.":
      "Sí, puedes mejorar o reducir tu plan en cualquier momento. Los cambios se aplican inmediatamente.",
    "Payments are made through PayPal for secure payments but you don't have to create an account and can just use your Debit/credit card (Visa, Mastecard...).":
      "Los pagos se realizan a través de PayPal de forma segura, pero no necesitas crear una cuenta y puedes usar tu tarjeta de débito/crédito (Visa, Mastercard...).",
    "No, exports reset at the beginning of each billing cycle.":
      "No, las exportaciones se reinician al inicio de cada ciclo de facturación.",
    "Yes, you can cancel your subscription at any time with no cancellation fees. Cancellation will take effect at the end of your cycle and your subscription will not renew.":
      "Sí, puedes cancelar tu suscripción en cualquier momento sin comisiones. La cancelación se hará efectiva al final de tu ciclo y no se renovará.",
    "16 videos/month": "16 videos/mes",
    "31 videos/month": "31 videos/mes",
    "100 videos/month": "100 videos/mes",
    "300 videos/month": "300 videos/mes",
    "1 export/day": "1 exportación/día",
    "Perfect to get started and post 4 videos per week":
      "Perfecto para empezar y publicar 4 videos por semana",
    "Post every day and grow your business":
      "Publica cada día y haz crecer tu negocio",
    "For freelancers and social media managers":
      "Para freelancers y gestores de redes sociales",
    "Post videos for multiple clients easily":
      "Publica videos para varios clientes fácilmente",
    "Temporary daily test plan for renewal checks":
      "Plan diario temporal de prueba para verificar renovaciones",
    "Start for": "Empieza por",
    "/month": "/mes",
    "/day": "/día",
    "Then monthly": "Luego mensual",
    "Then daily": "Luego diario",
    "Save and Subscribe": "Guardar y suscribirse",
    "Saving...": "Guardando...",
    "First name": "Nombre",
    "Last name": "Apellido",
    Email: "Correo electrónico",
    Password: "Contraseña",
    Country: "País",
    "Company name": "Nombre de la empresa",
    Address: "Dirección",
    "Zip code": "Código postal",
    City: "Ciudad",
    Phone: "Teléfono",
    "Limited exports": "Exportaciones limitadas",
    "Welcome back": "Bienvenido de nuevo",
    "Account Settings": "Configuración de la cuenta",
    "Profile Information": "Información del perfil",
    Security: "Seguridad",
    "Usage Statistics": "Estadísticas de uso",
    "Export Limit": "Límite de exportaciones",
    "Account Type": "Tipo de cuenta",
    "Save Changes": "Guardar cambios",
    "Danger Zone": "Zona de peligro",
    "Delete Account": "Eliminar cuenta",
    "Once you delete your account, there is no going back. Please be certain and don't forget to cancel your subscription before deleting your account, clicking on the Manage Subscription button.":
      "Una vez que elimines tu cuenta, no hay vuelta atrás. Asegúrate bien y no olvides cancelar tu suscripción antes de eliminar tu cuenta, haciendo clic en el botón Gestionar suscripción.",
    "Once you delete your account, there is no going back. Please be certain and don't forget to cancel your subscription before deleting your account, clicking on the Manage Abonnement button.":
      "Una vez que elimines tu cuenta, no hay vuelta atrás. Asegúrate bien y no olvides cancelar tu suscripción antes de eliminar tu cuenta, haciendo clic en el botón Gestionar suscripción.",
    Subscription: "Suscripción",
    "No active": "Ninguno activo",
    Cancelled: "Cancelado",
    "Available Plans": "Planes disponibles",
    "Billing History": "Historial de facturación",
    "Your paid subscription ended.": "Tu suscripción de pago terminó.",
    "Exports this month": "Exportaciones este mes",
    "No billing history yet": "Aún no hay historial de facturación",
    "Cancel Subscription": "Cancelar suscripción",
    "Create and manage your video projects":
      "Crea y gestiona tus proyectos de video",
    "Renders are automatically deleted after 2 months":
      "Los renderizados se eliminan automáticamente después de 2 meses",
    "Your video is ready!": "¡Tu video está listo!",

    Starter: "Empezar",
    Growth: "Crecer",
    Pro: "Pro",
    Agency: "Agencia",
    "Layer Info": "Información de capa",
    "Image Layer": "Capa de imagen",
    "Generate AI Video": "Generar video con IA",
    "Media Position": "Posición del medio",
    "Reset to Center": "Restablecer al centro",
    Animations: "Animaciones",
    "Entrance Animation": "Animación de entrada",
    "Exit Animation": "Animación de salida",
    "Continuous Animation": "Animación continua",
    "Upload image or video": "Subir imagen o video",
    "Record video with your camera": "Grabar video con tu cámara",
    "Choose camera": "Elegir cámara",
    "Which camera would you like to use for this recording?":
      "¿Qué cámara quieres usar para esta grabación?",
    "Use rear camera": "Usar cámara trasera",
    "Use front camera": "Usar cámara frontal",
    "Thank you! Your review has been submitted.":
      "¡Gracias! Tu reseña ha sido enviada.",
    "Rear camera is recommended when filming something in front of you.":
      "Se recomienda la cámara trasera para grabar algo frente a ti.",
    "Start recording with your camera and it will stop automatically at the end of the clip":
      "Empieza a grabar con tu cámara y la grabación se detendrá automáticamente al final del clip",
    "Preparing camera...": "Preparando la cámara...",
    "Recording...": "Grabando...",
    "Recording complete. Uploading video...":
      "Grabación terminada. Subiendo video...",
    "Camera preview": "Vista previa de la cámara",
    "Recording will stop automatically":
      "La grabación se detendrá automáticamente",
    "Camera recording is not supported by this browser":
      "Este navegador no admite la grabación con cámara",
    "Camera permission denied or unavailable":
      "Permiso de cámara denegado o cámara no disponible",
    "Upload image": "Subir imagen",
    "Remove image or video": "Eliminar imagen o video",
    "text layer": "capa de texto",
    "Text Content": "Contenido del texto",
    "Processing your video...": "Procesando tu video...",
    "Progress:": "Progreso:",
    "This may take a few minutes depending on video length and complexity":
      "Esto puede tardar unos minutos según la duración y complejidad del video",
    "You reached your monthly exports limit. Upgrade your plan or buy extra video exports.":
      "Has alcanzado tu límite mensual de exportaciones. Mejora tu plan o compra exportaciones de video adicionales.",
    "Go to pricing": "Ir a precios",
    "Upgrade for more exports": "Mejora para obtener más exportaciones",
    "Cancel your subscription at period end?":
      "¿Cancelar tu suscripción al final del período?",
    "Subscription cancellation scheduled. You keep access until the renewal date.":
      "Cancelación de suscripción programada. Mantienes el acceso hasta la fecha de renovación.",
    "Download Video": "Descargar video",
    "Modify Video": "Modificar video",
    "This video revision is no longer available to modify":
      "Esta versión del video ya no está disponible para modificarla",
    "Title (for Youtube only)": "Título (solo para YouTube)",
    "Caption/Description (for all the platforms)":
      "Leyenda/Descripción (para todas las plataformas)",
    "Share to all platforms": "Compartir en todas las plataformas",
    "Please connect at least one platform before sharing.":
      "Conecta al menos una plataforma antes de compartir.",
    "Shared successfully to": "Compartido correctamente en",
    "Failed to share to": "Error al compartir en",
    "Connect your social accounts first using the buttons below, then click Share to all platforms to publish automatically everywhere you're connected. You can connect one, two, or all platforms, and still use each platform's individual Share button after connecting. For TikTok, the video is sent to your account and you must finish posting inside the TikTok app or website.":
      "Conecta primero tus cuentas sociales con los botones de abajo y luego haz clic en «Compartir en todas las plataformas» para publicar automáticamente en todas las que estén conectadas. Puedes conectar una, dos o todas las plataformas, y también usar los botones de compartir individuales después de conectarlas. En TikTok, el video se envía a tu cuenta y debes finalizar la publicación en la app o en el sitio web de TikTok.",
    "Share on Instagram": "Compartir en Instagram",
    "Back to Dashboard": "Volver al panel",
    Delete: "Eliminar",
    Created: "Creado",
    Status: "Estado",
    completed: "completado",
    Template: "Plantilla",
    Progress: "Progreso",
    Properties: "Propiedades",
    "Select an editable layer to view properties":
      "Selecciona una capa editable para ver las propiedades",
    "Editable Layers": "Capas editables",
    "Export Video": "Exportar video",
    "No new visibility": "Sin nueva visibilidad",
    "No new clients": "Sin nuevos clientes",
    "No growth": "Sin crecimiento",
    Step: "Paso",
    "Step 1": "Paso 1",
    "Step 2": "Paso 2",
    "Step 3": "Paso 3",
    "Step 4": "Paso 4",
    "Video Templates": "Plantillas de video",
    "Choose from professionally designed templates and make them your own":
      "Elige entre plantillas diseñadas profesionalmente y personalízalas",
    "Search templates...": "Buscar plantillas...",
    Format: "Formato",
    "No templates found": "No se encontraron plantillas",
    "Try adjusting your search or filters":
      "Prueba ajustando tu búsqueda o filtros",
    "← Back to home": "← Volver al inicio",
    "1. Eligibility and Acceptance": "1. Elegibilidad y aceptación",
    "2. Our Service": "2. Nuestro servicio",
    "3. Account Registration and Security": "3. Registro de cuenta y seguridad",
    "4. Subscription Plans, Billing, and Renewal":
      "4. Planes de suscripción, facturación y renovación",
    "5. Cancellation and Refunds": "5. Cancelación y reembolsos",
    "6. License Types and Usage Rights":
      "6. Tipos de licencia y derechos de uso",
    "7. Template Access and Modification":
      "7. Acceso y modificación de plantillas",
    "8. User Content and Responsibilities":
      "8. Contenido del usuario y responsabilidades",
    "9. Prohibited Uses": "9. Usos prohibidos",
    "10. Intellectual Property": "10. Propiedad intelectual",
    "11. Feedback": "11. Comentarios",
    "12. Service Availability and Changes":
      "12. Disponibilidad del servicio y cambios",
    "13. Third-Party Services": "13. Servicios de terceros",
    "14. Privacy": "14. Privacidad",
    "15. Termination and Suspension": "15. Terminación y suspensión",
    "16. Disclaimers": "16. Exenciones de responsabilidad",
    "17. Limitation of Liability": "17. Limitación de responsabilidad",
    "18. Indemnification": "18. Indemnización",
    "19. Governing Law": "19. Ley aplicable",
    "20. Consumer Rights": "20. Derechos del consumidor",
    "21. Changes to Terms": "21. Cambios en los términos",
    "22. Entire Agreement": "22. Acuerdo completo",
    "23. Severability and Waiver": "23. Divisibilidad y renuncia",
    "24. Facebook / Instagram Login and Integration":
      "24. Inicio de sesión e integración de Facebook / Instagram",
    "25. Contact": "25. Contacto",
    "CreaVideos License Agreement": "Acuerdo de licencia de CreaVideos",
    "1. Grant of License": "1. Otorgamiento de licencia",
    "2. What You Can Do": "2. Qué puedes hacer",
    "3. What You Cannot Do": "3. Qué no puedes hacer",
    "4. View Limit and Extended Use":
      "4. Límite de visualizaciones y uso extendido",
    "5. Ownership": "5. Propiedad",
    "6. User Content": "6. Contenido del usuario",
    "7. AI-Generated Content (PixVerse)":
      "7. Contenido generado por IA (PixVerse)",
    "8. Termination of License": "8. Terminación de la licencia",
    "9. No Warranty": "9. Sin garantía",
    "10. Limitation of Liability": "10. Limitación de responsabilidad",
    "11. Contact": "11. Contacto",
    "1. Data Controller": "1. Responsable del tratamiento",
    "2. Personal Data We Collect": "2. Datos personales que recopilamos",
    "3. How We Use Your Data": "3. Cómo usamos tus datos",
    "4. Legal Basis (GDPR)": "4. Base legal (RGPD)",
    "5. Facebook / Instagram (Meta)": "5. Facebook / Instagram (Meta)",
    "6. Third-Party Services": "6. Servicios de terceros",
    "7. Data Retention": "7. Conservación de datos",
    "7.1 Data deletion instructions":
      "7.1 Instrucciones para eliminación de datos",
    "8. Your Rights (GDPR)": "8. Tus derechos (RGPD)",
    "9. Data Security": "9. Seguridad de los datos",
    "10. International Transfers": "10. Transferencias internacionales",
    "11. Cookies and Similar Technologies":
      "11. Cookies y tecnologías similares",
    "What Are Cookies?": "¿Qué son las cookies?",
    "How We Use Cookies": "Cómo usamos las cookies",
    "Authentication and session cookies": "Cookies de autenticación y sesión",
    "Security cookies": "Cookies de seguridad",
    "Payment-related functionality": "Funcionalidad relacionada con pagos",
    "Social media integration": "Integración con redes sociales",
    "No Analytics or Marketing Cookies": "Sin cookies de analítica o marketing",
    "Third-Party Services": "Servicios de terceros",
    "Changes to This Section": "Cambios en esta sección",
    "12. Changes to This Policy": "12. Cambios en esta política",
    "13. Contact": "13. Contacto",
    "These Terms + License + Privacy Policy = full agreement.":
      "Estos Términos + Licencia + Política de Privacidad = acuerdo completo.",
    "If a part is invalid, the rest remains enforceable.":
      "Si una parte es inválida, el resto sigue siendo aplicable.",
    "We do not sell this data.": "No vendemos estos datos.",
    "We never post without your explicit action.":
      "Nunca publicamos sin tu acción explícita.",
    "Used only to:": "Usados solo para:",
    "We may access:": "Podemos acceder a:",
    "Welcome to CreaVideos.online (the “Website”), owned and operated by CreaVideos – Renaud Jean Noel Pomies (“CreaVideos”, “we”, “our”, or “us”).":
      "Bienvenido a CreaVideos.online (el «Sitio web»), propiedad y operado por CreaVideos – Renaud Jean Noel Pomies («CreaVideos», «nosotros», «nuestro/a»).",
    "By accessing, browsing, creating an account, subscribing to, or using the Website and its services, you agree to be bound by these Terms of Service (“Terms”), as well as our":
      "Al acceder, navegar, crear una cuenta, suscribirte o usar el Sitio web y sus servicios, aceptas quedar sujeto a estos Términos de servicio («Términos»), así como a nuestra",
    ", which are incorporated by reference. If you do not agree, you must not use the Website.":
      ", que se incorporan por referencia. Si no estás de acuerdo, no debes usar el Sitio web.",
    "By using the Website, you represent and warrant that:":
      "Al usar el Sitio web, declaras y garantizas que:",
    "you are at least 18 years old or have legal authorization,":
      "tienes al menos 18 años o autorización legal,",
    "you have the legal capacity to enter into a binding agreement,":
      "tienes capacidad legal para celebrar un acuerdo vinculante,",
    "if acting on behalf of a company, you have authority to bind that entity.":
      "si actúas en nombre de una empresa, tienes autoridad para obligar a esa entidad.",
    "CreaVideos provides a subscription-based platform that allows users to:":
      "CreaVideos ofrece una plataforma por suscripción que permite a los usuarios:",
    "access video templates,": "acceder a plantillas de video,",
    "customize templates (text, images, videos),":
      "personalizar plantillas (texto, imágenes, videos),",
    "render and download finished videos,":
      "renderizar y descargar videos terminados,",
    "use related tools and features.":
      "usar herramientas y funciones relacionadas.",
    "You must create an account to access certain features.":
      "Debes crear una cuenta para acceder a ciertas funciones.",
    "You agree to:": "Aceptas:",
    "provide accurate and complete information,":
      "proporcionar información precisa y completa,",
    "keep your login credentials secure,":
      "mantener seguras tus credenciales de acceso,",
    "be responsible for all activity under your account.":
      "ser responsable de toda actividad realizada con tu cuenta.",
    "Account sharing is prohibited.": "Compartir cuenta está prohibido.",
    "Access is provided through subscription plans described on the Website.":
      "El acceso se proporciona mediante los planes de suscripción descritos en el Sitio web.",
    "You agree to pay all fees shown at purchase, including applicable taxes.":
      "Aceptas pagar todas las tarifas mostradas en la compra, incluidos los impuestos aplicables.",
    "Subscriptions renew automatically unless cancelled before the renewal date.":
      "Las suscripciones se renuevan automáticamente salvo que se cancelen antes de la fecha de renovación.",
    "We may change pricing. Changes apply at your next renewal.":
      "Podemos cambiar los precios. Los cambios se aplican en tu próxima renovación.",
    "Failed payments may result in suspension or termination of access.":
      "Los pagos fallidos pueden resultar en suspensión o cancelación del acceso.",
    "You may cancel anytime via your account or by contacting us.":
      "Puedes cancelar en cualquier momento desde tu cuenta o contactándonos.",
    "All purchases are non-refundable, except where required by law.":
      "Todas las compras son no reembolsables, salvo cuando la ley lo exija.",
    "Access continues until the end of your billing period.":
      "El acceso continúa hasta el final de tu período de facturación.",
    "You are responsible for all content you upload.":
      "Eres responsable de todo el contenido que subas.",
    "You may not:": "No puedes:",
    "All templates, software, and content belong to CreaVideos. You receive a license, not ownership.":
      "Todas las plantillas, software y contenido pertenecen a CreaVideos. Recibes una licencia, no propiedad.",
    "Any feedback you provide may be used freely without compensation.":
      "Cualquier comentario que proporciones podrá usarse libremente sin compensación.",
    "We may modify or discontinue services at any time.":
      "Podemos modificar o descontinuar servicios en cualquier momento.",
    "No guarantee of uptime or error-free operation.":
      "No se garantiza disponibilidad continua ni funcionamiento libre de errores.",
    "Payments are processed through PayPal.":
      "Los pagos se procesan a través de PayPal.",
    "We do not store full payment details.":
      "No almacenamos los datos completos de pago.",
    "By making a purchase, you agree to PayPal’s terms and privacy policy.":
      "Al realizar una compra, aceptas los términos y la política de privacidad de PayPal.",
    "Use of the Website is subject to our Privacy Policy.":
      "El uso del Sitio web está sujeto a nuestra Política de privacidad.",
    "The service is provided “as is” and “as available”.":
      "El servicio se proporciona «tal cual» y «según disponibilidad».",
    "We are not liable for indirect or consequential damages.":
      "No somos responsables por daños indirectos o consecuentes.",
    "Our total liability is limited to the amount you paid in the last 6 months.":
      "Nuestra responsabilidad total se limita al importe que pagaste en los últimos 6 meses.",
    "These Terms are governed by the laws of Spain.":
      "Estos Términos se rigen por las leyes de España.",
    "Nothing limits your rights under applicable consumer laws.":
      "Nada limita tus derechos según las leyes de consumo aplicables.",
    "We may update these Terms at any time.":
      "Podemos actualizar estos Términos en cualquier momento.",
    "This License Agreement (“Agreement”) governs the use of video templates and rendered videos available through CreaVideos.online (“CreaVideos”, “we”, “our”, or “us”).":
      "Este Acuerdo de licencia («Acuerdo») regula el uso de plantillas de video y videos renderizados disponibles a través de CreaVideos.online («CreaVideos», «nosotros», «nuestro/a»).",
    "By using the service and downloading or rendering videos, you agree to this Agreement.":
      "Al usar el servicio y descargar o renderizar videos, aceptas este Acuerdo.",
    "You are allowed to:": "Tienes permitido:",
    "You may NOT:": "NO puedes:",
    "Your license is valid only while your subscription is active.":
      "Tu licencia solo es válida mientras tu suscripción esté activa.",
    "Templates and videos are provided “as is”.":
      "Las plantillas y videos se proporcionan «tal cual».",
    "Welcome to CreaVideos.online (“Website”), operated by CreaVideos – Renaud Jean Noel Pomies (“CreaVideos”, “we”, “our”, or “us”).":
      "Bienvenido a CreaVideos.online («Sitio web»), operado por CreaVideos – Renaud Jean Noel Pomies («CreaVideos», «nosotros», «nuestro/a»).",
    "This Privacy Policy explains how we collect, use, disclose, and protect your personal data when you use our Website and services.":
      "Esta Política de privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tus datos personales cuando utilizas nuestro Sitio web y servicios.",
    "We comply with the General Data Protection Regulation (GDPR) and other applicable data protection laws.":
      "Cumplimos con el Reglamento General de Protección de Datos (RGPD) y otras leyes aplicables de protección de datos.",
    "We may collect the following categories of personal data:":
      "Podemos recopilar las siguientes categorías de datos personales:",
    "Payments are processed via PayPal.":
      "Los pagos se procesan mediante PayPal.",
    "We use your data to:": "Usamos tus datos para:",
    "We process your data under:": "Tratamos tus datos bajo:",
    "We use trusted third-party providers:":
      "Usamos proveedores externos de confianza:",
    "We keep your data:": "Conservamos tus datos:",
    "You may request deletion at any time.":
      "Puedes solicitar la eliminación en cualquier momento.",
    "You have the right to:": "Tienes derecho a:",
    "We implement appropriate security measures to protect your data.":
      "Implementamos medidas de seguridad adecuadas para proteger tus datos.",
    "However, no system is 100% secure.":
      "Sin embargo, ningún sistema es 100% seguro.",
    "Your data may be processed outside the EU (e.g. PayPal, PixVerse).":
      "Tus datos pueden procesarse fuera de la UE (p. ej., PayPal, PixVerse).",
    "We may update this Privacy Policy.":
      "Podemos actualizar esta Política de privacidad.",
    "4.2 Billing": "4.2 Facturación",
    "4.3 Automatic Renewal": "4.3 Renovación automática",
    "4.5 Failed Payments": "4.5 Pagos fallidos",
    "5.1 Cancellation": "5.1 Cancelación",
    "5.2 Refund Policy": "5.2 Política de reembolsos",
    "5.3 Effect of Cancellation": "5.3 Efecto de la cancelación",
    "You are granted a non-exclusive, non-transferable, non-sublicensable license.":
      "Se te concede una licencia no exclusiva, intransferible y no sublicenciable.",
    "A. Standard License": "A. Licencia estándar",
    "Commercial use allowed": "Uso comercial permitido",
    "Up to 500,000 total views": "Hasta 500.000 visualizaciones totales",
    "B. Enhanced License": "B. Licencia ampliada",
    "Required if:": "Requerida si:",
    "views exceed 500,000": "las visualizaciones superan 500.000",
    "used for TV, broadcast, or large-scale distribution":
      "se usa para TV, emisión o distribución a gran escala",
    "Contact:": "Contacto:",
    "You may:": "Puedes:",
    "customize templates,": "personalizar plantillas,",
    "use rendered videos for your business or clients.":
      "usar videos renderizados para tu negocio o clientes.",
    "resell or distribute templates,": "revender o distribuir plantillas,",
    "claim ownership of templates,": "reclamar propiedad de las plantillas,",
    "build competing template platforms.":
      "crear plataformas de plantillas competidoras.",
    "You confirm you have all rights to:":
      "Confirmas que tienes todos los derechos sobre:",
    "images,": "imágenes,",
    "text,": "texto,",
    "logos.": "logotipos.",
    "You are responsible for compliance with laws and platform policies.":
      "Eres responsable del cumplimiento de las leyes y políticas de las plataformas.",
    "violate laws,": "violar leyes,",
    "infringe rights,": "infringir derechos,",
    "upload harmful content,": "subir contenido dañino,",
    "reverse engineer or scrape the service,":
      "hacer ingeniería inversa o extraer datos del servicio,",
    "bypass protections,": "eludir protecciones,",
    "share accounts,": "compartir cuentas,",
    "misuse templates.": "hacer mal uso de las plantillas.",
    "The Website may rely on third-party providers to deliver certain features.":
      "El Sitio web puede depender de proveedores externos para ofrecer ciertas funciones.",
    "These include:": "Estos incluyen:",
    "13.1 Payment Processing (PayPal)": "13.1 Procesamiento de pagos (PayPal)",
    "13.2 AI Video Generation (PixVerse)":
      "13.2 Generación de video con IA (PixVerse)",
    "CreaVideos uses third-party AI services, including PixVerse, to generate videos from images.":
      "CreaVideos utiliza servicios de IA de terceros, incluido PixVerse, para generar videos a partir de imágenes.",
    "By using these features, you acknowledge that:":
      "Al usar estas funciones, reconoces que:",
    "your uploaded images, prompts, and content may be processed by PixVerse,":
      "tus imágenes, prompts y contenido subidos pueden ser procesados por PixVerse,",
    "this processing is required to deliver the service,":
      "este procesamiento es necesario para prestar el servicio,",
    "CreaVideos is not responsible for the output generated by AI systems.":
      "CreaVideos no es responsable del resultado generado por sistemas de IA.",
    "We may suspend or terminate your account if:":
      "Podemos suspender o cancelar tu cuenta si:",
    "you violate these Conditions,": "incumples estas Condiciones,",
    "payment fails,": "falla el pago,",
    "misuse occurs.": "se produce un uso indebido.",
    "We do not guarantee:": "No garantizamos:",
    "uninterrupted service,": "servicio ininterrumpido,",
    "error-free operation,": "funcionamiento sin errores,",
    "platform acceptance of your videos.":
      "aceptación de tus videos por las plataformas.",
    "You agree to indemnify CreaVideos for any claims resulting from:":
      "Aceptas indemnizar a CreaVideos por cualquier reclamación derivada de:",
    "your use of the service,": "tu uso del servicio,",
    "your content,": "tu contenido,",
    "your violations of these Conditions.":
      "tus incumplimientos de estas Condiciones.",
    "CreaVideos may allow users to connect accounts via Facebook or Instagram (“Meta Platforms”) for login, account linking, or sharing content.":
      "CreaVideos puede permitir a los usuarios conectar cuentas mediante Facebook o Instagram («Plataformas Meta») para iniciar sesión, vincular cuentas o compartir contenido.",
    "24.1 Data Access": "24.1 Acceso a datos",
    "name,": "nombre,",
    "email,": "correo electrónico,",
    "profile picture,": "foto de perfil,",
    "account ID,": "ID de cuenta,",
    "other authorized data.": "otros datos autorizados.",
    "24.2 Use of Data": "24.2 Uso de datos",
    "authenticate users,": "autenticar usuarios,",
    "enable login,": "habilitar inicio de sesión,",
    "allow sharing,": "permitir compartir,",
    "operate and improve the service.": "operar y mejorar el servicio.",
    "24.3 Posting Permissions": "24.3 Permisos de publicación",
    "24.4 Disconnection": "24.4 Desconexión",
    "You may disconnect anytime via:":
      "Puedes desconectar en cualquier momento mediante:",
    "your CreaVideos account, or": "tu cuenta de CreaVideos, o",
    "24.5 Meta Compliance": "24.5 Cumplimiento de Meta",
    "Use must comply with Meta policies. We are not responsible for their platform changes.":
      "El uso debe cumplir las políticas de Meta. No somos responsables de cambios en su plataforma.",
    "Subject to an active subscription and compliance with the Conditions of Service, CreaVideos grants you a:":
      "Sujeto a una suscripción activa y al cumplimiento de las Condiciones del servicio, CreaVideos te concede una:",
    "non-exclusive": "no exclusiva",
    "non-transferable": "intransferible",
    "non-sublicensable": "no sublicenciable",
    revocable: "revocable",
    "license to use videos created using our templates.":
      "licencia para usar videos creados con nuestras plantillas.",
    "use rendered videos for commercial and personal purposes":
      "usar videos renderizados con fines comerciales y personales",
    "use videos for:": "usar videos para:",
    "social media (Instagram, Facebook, TikTok, etc.)":
      "redes sociales (Instagram, Facebook, TikTok, etc.)",
    "websites and landing pages": "sitios web y páginas de aterrizaje",
    "digital advertising (Meta Ads, Google Ads, etc.)":
      "publicidad digital (Meta Ads, Google Ads, etc.)",
    "client work (if you are an agency or freelancer)":
      "trabajo para clientes (si eres agencia o freelancer)",
    "You may modify templates only through the CreaVideos platform.":
      "Solo puedes modificar plantillas a través de la plataforma CreaVideos.",
    "resell, sublicense, share, or distribute templates":
      "revender, sublicenciar, compartir o distribuir plantillas",
    "provide templates as part of another platform or service":
      "ofrecer plantillas como parte de otra plataforma o servicio",
    "redistribute templates in editable form":
      "redistribuir plantillas en formato editable",
    "extract assets to build a competing template library":
      "extraer recursos para crear una biblioteca de plantillas competidora",
    "use templates to create a competing SaaS or product":
      "usar plantillas para crear un SaaS o producto competidor",
    "Standard License": "Licencia estándar",
    "Includes usage up to 500,000 total views":
      "Incluye uso de hasta 500.000 visualizaciones totales",
    "Enhanced License Required": "Se requiere licencia ampliada",
    "You must contact us if:": "Debes contactarnos si:",
    "usage exceeds 500,000 views": "el uso supera 500.000 visualizaciones",
    "videos are used for:": "los videos se usan para:",
    TV: "TV",
    cinema: "cine",
    "large-scale broadcast or streaming": "emisión o streaming a gran escala",
    "All templates remain the property of CreaVideos":
      "Todas las plantillas siguen siendo propiedad de CreaVideos",
    "You own the final rendered videos, subject to this license":
      "Eres propietario de los videos finales renderizados, sujeto a esta licencia",
    "No ownership is transferred for templates or platform technology":
      "No se transfiere propiedad sobre las plantillas ni la tecnología de la plataforma",
    "You retain ownership of content you upload (images, videos, text).":
      "Conservas la propiedad del contenido que subes (imágenes, videos, texto).",
    "You grant us a limited license to:":
      "Nos concedes una licencia limitada para:",
    "process it": "procesarlo",
    "render videos": "renderizar videos",
    "operate the service": "operar el servicio",
    "You are responsible for ensuring you have the rights to use your content.":
      "Eres responsable de asegurarte de que tienes los derechos para usar tu contenido.",
    "Videos may be generated using AI tools (e.g. PixVerse).":
      "Los videos pueden generarse usando herramientas de IA (p. ej. PixVerse).",
    "You acknowledge:": "Reconoces:",
    "AI results may vary": "los resultados de IA pueden variar",
    "outputs may not be unique": "las salidas pueden no ser únicas",
    "outputs may resemble other content":
      "las salidas pueden parecerse a otro contenido",
    "CreaVideos does not guarantee:": "CreaVideos no garantiza:",
    uniqueness: "unicidad",
    "copyright clearance": "libre de derechos de autor",
    "suitability for all uses": "idoneidad para todos los usos",
    "After cancellation:": "Después de la cancelación:",
    "you may continue using previously downloaded videos":
      "puedes seguir usando videos descargados anteriormente",
    "you lose access to templates and editing tools":
      "pierdes acceso a plantillas y herramientas de edición",
    "If you violate this Agreement:": "Si incumples este Acuerdo:",
    "your license may be revoked immediately":
      "tu licencia puede ser revocada inmediatamente",
    performance: "rendimiento",
    "legal suitability": "idoneidad legal",
    "platform acceptance (ads, social media, etc.)":
      "aceptación en plataformas (anuncios, redes sociales, etc.)",
    "CreaVideos is not liable for:": "CreaVideos no es responsable de:",
    "misuse of videos": "uso indebido de videos",
    "copyright claims from user-uploaded content":
      "reclamaciones de derechos de autor por contenido subido por usuarios",
    "business losses": "pérdidas comerciales",
    "The data controller responsible for your personal data is:":
      "El responsable del tratamiento de tus datos personales es:",
    "2.1 Account Information": "2.1 Información de la cuenta",
    Name: "Nombre",
    "E-mail address": "Dirección de correo electrónico",
    "(encrypted)": "(cifrado)",
    "2.2 Payment Information": "2.2 Información de pago",
    "We may receive:": "Podemos recibir:",
    "payment confirmation": "confirmación de pago",
    "subscription status": "estado de suscripción",
    "transaction ID": "ID de transacción",
    "billing-related metadata": "metadatos relacionados con facturación",
    "2.3 User Content": "2.3 Contenido del usuario",
    "Text entered into templates": "Texto introducido en plantillas",
    "Images or videos uploaded": "Imágenes o videos subidos",
    "Generated videos": "Videos generados",
    "2.4 Usage Data": "2.4 Datos de uso",
    "IP address": "Dirección IP",
    "browser type": "tipo de navegador",
    "device information": "información del dispositivo",
    "pages visited": "páginas visitadas",
    "usage behavior": "comportamiento de uso",
    "2.5 Meta (Facebook / Instagram) Data":
      "2.5 Datos de Meta (Facebook / Instagram)",
    "If you connect your account:": "Si conectas tu cuenta:",
    "permissions granted": "permisos concedidos",
    "provide and operate the service": "proporcionar y operar el servicio",
    "create and manage your account": "crear y gestionar tu cuenta",
    "process subscriptions and payments": "procesar suscripciones y pagos",
    "allow video creation and rendering":
      "permitir creación y renderizado de videos",
    "enable social media sharing": "habilitar compartir en redes sociales",
    "communicate with you": "comunicarnos contigo",
    "improve performance and features":
      "mejorar el rendimiento y las funciones",
    "comply with legal obligations": "cumplir obligaciones legales",
    "Contract → to provide the service": "Contrato → para prestar el servicio",
    "Legitimate interest → to improve and secure the platform":
      "Interés legítimo → para mejorar y asegurar la plataforma",
    "Consent → for optional features (e.g. Meta login)":
      "Consentimiento → para funciones opcionales (p. ej. inicio con Meta)",
    "Legal obligation → accounting, taxes":
      "Obligación legal → contabilidad, impuestos",
    "If you connect via Meta:": "Si te conectas vía Meta:",
    "we only access data you approve":
      "solo accedemos a los datos que apruebas",
    "we use it for login and sharing":
      "lo usamos para inicio de sesión y compartir",
    "we never post without your action": "nunca publicamos sin tu acción",
    "To enable these features, we may store limited Meta-related connection data such as account IDs, usernames, granted permission status, and access tokens needed to perform user-initiated sharing.":
      "Para habilitar estas funciones, podemos almacenar datos limitados de conexión con Meta, como ID de cuenta, nombres de usuario, estado de permisos concedidos y tokens de acceso necesarios para realizar comparticiones iniciadas por el usuario.",
    "We disclose Meta-related data only to Meta Platforms as required to authenticate your account and process your explicit sharing requests. We do not sell this data or use it for independent advertising.":
      "Divulgamos datos relacionados con Meta únicamente a Meta Platforms cuando es necesario para autenticar tu cuenta y procesar tus solicitudes explícitas de compartición. No vendemos estos datos ni los usamos para publicidad independiente.",
    "You can disconnect anytime via:":
      "Puedes desconectar en cualquier momento mediante:",
    "your account settings": "la configuración de tu cuenta",
    "6.1 PayPal (Payments)": "6.1 PayPal (Pagos)",
    "Used to process subscriptions securely.":
      "Usado para procesar suscripciones de forma segura.",
    "PayPal acts as an independent data controller.":
      "PayPal actúa como responsable del tratamiento independiente.",
    "Their privacy policy applies to payment data.":
      "Su política de privacidad se aplica a los datos de pago.",
    "6.2 PixVerse (AI Video Generation)":
      "6.2 PixVerse (Generación de video con IA)",
    "This means:": "Esto significa:",
    "images and prompts you submit may be processed by PixVerse":
      "las imágenes y prompts que envías pueden ser procesados por PixVerse",
    "processing is necessary to deliver the service":
      "el procesamiento es necesario para prestar el servicio",
    "We only send required data.": "Solo enviamos los datos necesarios.",
    "6.3 Google / YouTube (OAuth and YouTube upload)":
      "6.3 Google / YouTube (OAuth y carga a YouTube)",
    "If you connect YouTube, we use Google OAuth and YouTube API services to authenticate your account and upload videos only when you request sharing.":
      "Si conectas YouTube, usamos Google OAuth y los servicios de la API de YouTube para autenticar tu cuenta y subir videos solo cuando solicitas compartir.",
    "For this integration:": "Para esta integración:",
    "we may receive your Google account basic profile/channel information and OAuth tokens":
      "podemos recibir información básica de perfil/canal de tu cuenta de Google y tokens OAuth",
    "we use this data only to maintain the connection and perform user-initiated YouTube uploads":
      "usamos estos datos solo para mantener la conexión y realizar cargas a YouTube iniciadas por el usuario",
    "we do not transfer Google user data to third parties except as required to provide this feature":
      "no transferimos datos de usuario de Google a terceros salvo cuando sea necesario para proporcionar esta función",
    "6.4 TikTok (OAuth and upload-to-TikTok flow)":
      "6.4 TikTok (OAuth y flujo de carga a TikTok)",
    "If you connect TikTok, we use TikTok OAuth and upload APIs to send your rendered video to TikTok when you choose to share.":
      "Si conectas TikTok, usamos TikTok OAuth y APIs de carga para enviar tu video renderizado a TikTok cuando eliges compartirlo.",
    "Posting is user-controlled: after upload, you may need to finish publishing inside TikTok.":
      "La publicación está controlada por el usuario: después de la carga, es posible que debas terminar de publicar dentro de TikTok.",
    "while your account is active": "mientras tu cuenta esté activa",
    "as needed for legal obligations (e.g. accounting)":
      "según sea necesario por obligaciones legales (p. ej. contabilidad)",
    "If you want CreaVideos to delete your data, please follow these steps:":
      "Si quieres que CreaVideos elimine tus datos, sigue estos pasos:",
    "Send an email to reno@creavideos.online with the subject line":
      "Envía un correo a reno@creavideos.online con el asunto",
    "Include the email address linked to your CreaVideos account and, if applicable, your Facebook/Instagram account ID.":
      "Incluye la dirección de correo vinculada a tu cuenta de CreaVideos y, si aplica, el ID de tu cuenta de Facebook/Instagram.",
    "We may ask for verification to confirm account ownership before processing your request.":
      "Podemos solicitar verificación para confirmar la titularidad de la cuenta antes de procesar tu solicitud.",
    "After verification, we will delete or anonymize eligible personal data within a reasonable period, except for information we must keep for legal, fraud-prevention, or accounting purposes.":
      "Tras la verificación, eliminaremos o anonimizaremos los datos personales elegibles en un plazo razonable, salvo la información que debamos conservar por motivos legales, prevención de fraude o contabilidad.",
    "access your data": "acceder a tus datos",
    "correct your data": "corregir tus datos",
    "delete your data (“right to be forgotten”)":
      "eliminar tus datos («derecho al olvido»)",
    "restrict processing": "restringir el tratamiento",
    "object to processing": "oponerte al tratamiento",
    "data portability": "portabilidad de datos",
    "To exercise your rights:": "Para ejercer tus derechos:",
    "You also have the right to file a complaint with a supervisory authority in the EU.":
      "También tienes derecho a presentar una reclamación ante una autoridad de control en la UE.",
    "When this happens, we ensure appropriate safeguards (e.g. standard contractual clauses).":
      "Cuando esto ocurre, garantizamos salvaguardas adecuadas (p. ej. cláusulas contractuales tipo).",
    "CreaVideos uses cookies and similar technologies to ensure the proper functioning of the Website and to provide essential features.":
      "CreaVideos utiliza cookies y tecnologías similares para garantizar el correcto funcionamiento del Sitio web y ofrecer funciones esenciales.",
    "Cookies are small text files stored on your device when you visit a website. They help websites function correctly and improve user experience.":
      "Las cookies son pequeños archivos de texto almacenados en tu dispositivo cuando visitas un sitio web. Ayudan a que los sitios funcionen correctamente y mejoran la experiencia del usuario.",
    "We currently use only cookies and similar technologies that are strictly necessary for the operation of the Website.":
      "Actualmente solo usamos cookies y tecnologías similares estrictamente necesarias para el funcionamiento del Sitio web.",
    "To allow you to log in, stay logged in, and securely access your account.":
      "Para permitirte iniciar sesión, mantenerla iniciada y acceder de forma segura a tu cuenta.",
    "To protect against fraudulent activity and ensure the security of the Website.":
      "Para proteger frente a actividad fraudulenta y garantizar la seguridad del Sitio web.",
    "To enable secure payment processing through our payment provider (PayPal).":
      "Para habilitar el procesamiento seguro de pagos mediante nuestro proveedor de pagos (PayPal).",
    "To allow you to connect your account and share videos to platforms such as Facebook and Instagram when you choose to do so.":
      "Para permitirte conectar tu cuenta y compartir videos en plataformas como Facebook e Instagram cuando así lo elijas.",
    "These cookies are essential for providing the services you request and cannot be disabled without affecting the functionality of the Website.":
      "Estas cookies son esenciales para prestar los servicios que solicitas y no pueden desactivarse sin afectar la funcionalidad del Sitio web.",
    "CreaVideos does not currently use analytics, advertising, or tracking cookies.":
      "CreaVideos actualmente no utiliza cookies de analítica, publicidad ni seguimiento.",
    "We do not track your browsing behavior for marketing purposes and do not use third-party tracking tools such as advertising pixels.":
      "No rastreamos tu comportamiento de navegación con fines de marketing ni usamos herramientas de seguimiento de terceros como píxeles publicitarios.",
    "Some essential features rely on trusted third-party providers, including:":
      "Algunas funciones esenciales dependen de proveedores externos de confianza, entre ellos:",
    "PayPal for payment processing": "PayPal para el procesamiento de pagos",
    "Meta Platforms (Facebook / Instagram) for login and sharing features":
      "Meta Platforms (Facebook / Instagram) para funciones de inicio de sesión y compartir",
    "These providers may use their own cookies or similar technologies as part of the services they provide. Their use of data is governed by their respective privacy policies.":
      "Estos proveedores pueden usar sus propias cookies o tecnologías similares como parte de los servicios que prestan. Su uso de datos se rige por sus respectivas políticas de privacidad.",
    "If we introduce analytics or marketing cookies in the future, we will update this section and implement a cookie consent mechanism allowing you to manage your preferences.":
      "Si introducimos cookies analíticas o de marketing en el futuro, actualizaremos esta sección e implementaremos un mecanismo de consentimiento de cookies que te permita gestionar tus preferencias.",
    "Your photo posts don't reach new clients.":
      "Tus publicaciones con fotos no llegan a nuevos clientes.",
    "Turn the photos you already post into videos and reach more people without having to create more content.":
      "Convierte las fotos que ya publicas en videos y llega a más personas sin tener que crear más contenido.",
    "With CreaVideos, turn your photos into short social media videos in about 2 minutes and publish them directly to all your social platforms with just one click.":
      "Con CreaVideos, convierte tus fotos en videos cortos para redes sociales en unos 2 minutos y publícalos directamente en todas tus plataformas sociales con un solo clic.",
    "Start your first month for ": "Empieza tu primer mes por ",
    " instead of ": " en lugar de ",
    "Plans from ": "Planes desde ",
    "/month after your first month. Cancel anytime.":
      "/mes después del primer mes. Cancela cuando quieras.",
    "Why post a photo when you can post a video?":
      "¿Por qué publicar una foto cuando puedes publicar un video?",
    "Videos are pushed to people who don't follow you, while image posts are only seen by your existing followers.":
      "Los videos llegan a personas que no te siguen, mientras que las publicaciones con fotos solo las ven tus seguidores actuales.",
    "You know you need to post videos regularly. But they take time and money.":
      "Sabes que necesitas publicar videos con regularidad. Pero requieren tiempo y dinero.",
    "Ideally, you should post 3 or 4 videos every week to reach new people.":
      "Lo ideal sería publicar 3 o 4 videos cada semana para llegar a nuevas personas.",
    "But filming and professionally editing that many videos every week quickly becomes too expensive for most small businesses.":
      "Pero grabar y editar profesionalmente tantos videos cada semana pronto resulta demasiado caro para la mayoría de los pequeños negocios.",
    "So what happens?": "Entonces, ¿qué ocurre?",
    "You post pictures instead.": "Publicas fotos en su lugar.",
    "They're quick, they're easy, and you already have them.":
      "Son rápidas, son fáciles y ya las tienes.",
    "CreaVideos was created to make turning those same pictures into videos almost as easy as posting the picture itself.":
      "CreaVideos se creó para que convertir esas mismas fotos en videos sea casi tan fácil como publicar la propia foto.",
    "Don't change what you post. Change how you post it.":
      "No cambies lo que publicas. Cambia cómo lo publicas.",
    "What you do now": "Lo que haces ahora",
    "Take a photo → Write a caption → Publish":
      "Haz una foto → Escribe un texto → Publica",
    "With CreaVideos": "Con CreaVideos",
    "Take the same photo → Choose a template → Edit the text → Publish a video":
      "Usa la misma foto → Elige una plantilla → Edita el texto → Publica un video",
    "Just 2 extra minutes.": "Solo 2 minutos más.",
    "Instead of publishing a photo, you're publishing a video that will be shown to people who don't follow you.":
      "En lugar de publicar una foto, publicas un video que se mostrará a personas que no te siguen.",
    "You're not creating new content. You're simply turning the content you already create into videos.":
      "No estás creando contenido nuevo. Simplemente conviertes en videos el contenido que ya creas.",
    "Same content. More reach.": "El mismo contenido. Más alcance.",
    "And there's another advantage.": "Y hay otra ventaja.",
    "Because your content is now a video, you can also publish it on TikTok. Many businesses don't post on TikTok because they only create photo posts.":
      "Como ahora tu contenido es un video, también puedes publicarlo en TikTok. Muchos negocios no publican en TikTok porque solo crean publicaciones con fotos.",
    "With CreaVideos you can connect to your Instagram, Facebook, TikTok and YouTube accounts and share the video on all 4 platforms with just one click.":
      "Con CreaVideos puedes conectar tus cuentas de Instagram, Facebook, TikTok y YouTube y compartir el video en las 4 plataformas con un solo clic.",
    "If you post regularly on social media and want an easier, faster way to create short videos, CreaVideos is for you. No video editing experience needed.":
      "Si publicas con regularidad en redes sociales y quieres una forma más fácil y rápida de crear videos cortos, CreaVideos es para ti. No necesitas experiencia en edición de video.",
    "Real estate agents showcasing properties":
      "Agentes inmobiliarios mostrando propiedades",
    "Any business posting on social media":
      "Cualquier negocio que publique en redes sociales",
    "Don't post the same kind of video every day":
      "No publiques el mismo tipo de video todos los días",
    "CreaVideos gives you different ways to turn your everyday content into videos, so your social media stays fresh and varied.":
      "CreaVideos te ofrece distintas formas de convertir tu contenido cotidiano en videos para que tus redes sociales se mantengan frescas y variadas.",
    "AI Image-to-Video": "Imagen a video con IA",
    "Turn a photo into a moving video.":
      "Convierte una foto en un video con movimiento.",
    "Simple & Visual Templates": "Plantillas simples y visuales",
    "Turn your photos into animated slideshows.":
      "Convierte tus fotos en presentaciones animadas.",
    "Edited Video Templates": "Plantillas de video editado",
    "Upload your clips and let CreaVideos do the editing.":
      "Sube tus clips y deja que CreaVideos se encargue de la edición.",
    "Fun & Creative Videos": "Videos divertidos y creativos",
    "Create entertaining posts and ads with actors.":
      "Crea publicaciones y anuncios entretenidos con actores.",
    "Client Review Videos": "Videos de reseñas de clientes",
    "Collect authentic customer testimonials with a QR code.":
      "Recopila testimonios auténticos de clientes con un código QR.",
    "Five types of videos. So your posts never get repetitive.":
      "Cinco tipos de videos para que tus publicaciones nunca sean repetitivas.",
    "Turn your photos into professional-looking social media videos.":
      "Convierte tus fotos en videos de aspecto profesional para redes sociales.",
    "Nothing beats a professional video":
      "Nada supera a un video profesional",
    "Professionally filmed and edited videos are one of the best ways to promote your business on social media.":
      "Los videos grabados y editados profesionalmente son una de las mejores formas de promocionar tu negocio en redes sociales.",
    "If you have the budget, you should absolutely create them.":
      "Si tienes presupuesto, sin duda deberías crearlos.",
    "CreaVideos isn't here to replace that.":
      "CreaVideos no está aquí para reemplazarlo.",
    "It's here for all those other posts where you would normally publish a picture.":
      "Está aquí para todas esas otras publicaciones en las que normalmente publicarías una foto.",
    "Instead of photo post, spend two extra minutes and turn it into a video that will be shown to non followers.":
      "En lugar de publicar una foto, dedica dos minutos más y conviértela en un video que se mostrará a personas que no te siguen.",
    "Post videos regularly without the professional-video budget":
      "Publica videos con regularidad sin el presupuesto de un video profesional",
    "Create up to 16 videos every month.": "Crea hasta 16 videos al mes.",
    "That's enough to publish ": "Es suficiente para publicar ",
    "4 videos every week.": "4 videos cada semana.",
    "Starting from about ": "Desde aproximadamente ",
    " per video.": " por video.",
    "Plans start at ": "Los planes empiezan en ",
    "You're already creating the content.": "Ya estás creando el contenido.",
    "You're already taking the photos.": "Ya estás tomando las fotos.",
    "You're already writing the captions.": "Ya estás escribiendo los textos.",
    "Now spend just two extra minutes...":
      "Ahora dedica solo dos minutos más...",
    "and publish videos instead.": "y publica videos en su lugar.",
    "So... what's your excuse for not posting videos more often?":
      "Entonces... ¿cuál es tu excusa para no publicar videos más a menudo?",
  },
};

export const translateText = (text, lang) => {
  if (!text || !lang || lang === "en") {
    return text;
  }
  const dictionary = TEXT_TRANSLATIONS[lang] || {};
  if (dictionary[text]) {
    return dictionary[text];
  }

  const numberedScene = text.match(/^(Scene|Delete Scene) (\d+)( media)?$/);
  if (numberedScene) {
    const [, label, sceneNumber, suffix = ""] = numberedScene;
    const translation = dictionary[`${label} {number}${suffix}`];
    if (translation) return translation.replace("{number}", sceneNumber);
  }

  let translated = text;
  Object.entries(dictionary).forEach(([source, target]) => {
    if (translated.includes(source)) {
      translated = translated.split(source).join(target);
    }
  });

  return translated;
};

export const translateCurrentPathText = (text) => {
  if (typeof window === "undefined") {
    return text;
  }
  const lang = getPathLanguage(window.location.pathname);
  return translateText(text, lang);
};
